export const REDIRECT_IT = {
'/2013/11/' : '/veggie-passion/veggie-passion',
'/2014/11/' : '/veggie-passion/veggie-passion',
'/2014/12/' : '/veggie-passion/veggie-passion',
'/2019/2/' : '/veggie-passion/veggie-passion',
'/2019/3/' : '/veggie-passion/veggie-passion',
'/agricoltore-a-sorpresa/' : '/',
'/allergeni/' : '/azienda/novita',
'/bebio' : '/be-bio',
'/bebio/BeBio-gamma-prodotti' : '/prodotti/bio',
'/bebio/con-bebio-e-facile-essere-bio/' : '/be-bio',
'/bebio/la-produzione-biologica/' : '/produzione-biologica',
'/bebio/le-nostre-verdure-bio/' : '/verdure-bio',
'/bonduelle/' : '/azienda/novita',
'/bonduelle/buoni_in_tavola' : '/promozioni',
'/bonduelle/buonisconto' : '/promozioni',
'/bonduelle/il-gruppo/' : '/azienda/il-gruppo',
'/bonduelle/nutrizione-benessere/' : '/veggie-passion/veggie-passion',
'/bonduelle/nutrizione-benessere/conoscere-le-verdure/' : '/azienda/abc-verdure',
'/bonduelle/qualita/' : '/azienda/articolo/la-nostra-qualita/1768/1768',
'/bonduelle/sviluppo-sostenibile/' : '/azienda/bonduelle-si-impegna',
'/bonduelle/tecnologie/' : '/azienda/la-nostra-filiera',
'/bonduelle/tecnologie/conserve/' : '/azienda/articolo/la-filiera-delle-conserve/1770/1770',
'/bonduelle/tecnologie/il-fresco/' : '/azienda/articolo/la-filiera-del-fresco/1769/1769',
'/bonduelle/tecnologie/surgelati/' : '/azienda/articolo/la-filiera-dei-surgelati/1771/1771',
'/bonduelle-camp' : '/',
'/bonduelle-food-service/' : '/contatto',
'/bonduelle-lancia-la-carta-delle-insalate-linsalata-protagonista-dei-tuoi-piatti/' : '/',
'/bonduelle-si-impegna' : '/azienda/bonduelle-si-impegna',
'/bonduelle-si-impegna-temp' : '/prodotti/p/tempura-di-verdure/03083681079449',
'/bonduelle-si-impegna-temp/' : '/prodotti/p/tempura-di-verdure/03083681079449',
'/bonduelletv/' : '/',
'/bonduelletv/8409/' : '/',
'/bonduelletv/bonduelle-natura-padella-la-cena-perfetta-post-gara-amiche-ranningcharlotte/' : '/',
'/bonduelletv/bonduelletvcoltiviamo-le-vostre-esigenze/' : '/',
'/bonduelletv/bonduelletvfrancesco-mozzarella-rucola/' : '/',
'/bonduelletv/bonduelletvinsalata-giorgio/' : '/',
'/bonduelletv/bonduelletvinsalata-lenticchie-alla-curcuma-zucca/' : '/',
'/bonduelletv/bonduelletvlattughino-mario/' : '/',
'/bonduelletv/bonduelletvvideo-esempio-scendiamo-campo/' : '/',
'/bonduelletv/cannellini-fagiolini-patate-ai-profumi/' : '/',
'/bonduelletv/carbonara-vegetale-fave-bonduelle-3/' : '/',
'/bonduelletv/cassoni-tigelle-rucola-carote-bonduelle/' : '/',
'/bonduelletv/cheesecake-salata-ricetta-video/' : '/',
'/bonduelletv/coltivare-pomodori-la-doppia-rincalzatura/' : '/',
'/bonduelletv/cotoletta-alla-milanese-songino-bonduelle/' : '/',
'/bonduelletv/crema-piselli-iceberg-bonduelle-capesante/' : '/',
'/bonduelletv/crespelle-mais-fiori-zucca-cotto-scamorza-mix-croccante-bonduelle/' : '/',
'/bonduelletv/crostoni-fagioli-borlotti-zucca-fili-gustosi-bonduelle/' : '/',
'/bonduelletv/cuore-pasta-choux-fagiolini-trio-freschezza/' : '/',
'/bonduelletv/dalla-produzione-alla-distribuzione/' : '/',
'/bonduelletv/dischetti-ricotta-piselli-carotine-bonduelle/' : '/',
'/bonduelletv/fagiolini-insalata-ciliegini-alle-erbe/' : '/',
'/bonduelletv/fili-gustosi-polpette-verdure/' : '/',
'/bonduelletv/focaccia-padella-mais-fagioli-rossi/' : '/',
'/bonduelletv/focaccine-halloween-hummus/' : '/',
'/bonduelletv/fragole-nuove-piante-stolone/' : '/',
'/bonduelletv/fregola-piselli-fave-rucola-bonduelle/' : '/',
'/bonduelletv/frittelle-mais-condi-o-cuoci-bonduelle/' : '/',
'/bonduelletv/gli-agricoltori-bonduelle-il-responsabile-del-campo/' : '/',
'/bonduelletv/il-controllo-qualita/' : '/',
'/bonduelletv/il-mestiere-del-produttore/' : '/',
'/bonduelletv/il-nonno-sante/' : '/',
'/bonduelletv/il-trapianto-delle-fragole-nellorto/' : '/',
'/bonduelletv/il-tuo-tocco/' : '/',
'/bonduelletv/imbianchimento-cardi/' : '/',
'/bonduelletv/insalata-armonia-zucca-borlotti-bonduelle/' : '/',
'/bonduelletv/insalata-a-tutto-gusto-bonduelle/' : '/',
'/bonduelletv/insalata-esotica-gran-mix-gustoso-bonduelle/' : '/',
'/bonduelletv/insalata-fiorita-mix-vivace-bonduelle/' : '/',
'/bonduelletv/insalata-germogli-mandarini-pesto-menta/' : '/',
'/bonduelletv/insalata-humus-ceci-cialde-parmigiano/' : '/',
'/bonduelletv/insalata-lenticchie-sinfonia-iceberg-carote-bonduelle/' : '/',
'/bonduelletv/insalata-primavera-mais-piselli-bonduelle/' : '/',
'/bonduelletv/insalata-tirolese-insiemi-gustosi-tenere-insalatine/' : '/',
'/bonduelletv/i-semi-della-zucca/' : '/',
'/bonduelletv/la-linea-produzione/' : '/',
'/bonduelletv/langolo-degli-ortaggi-curiosi-la-tuberina/' : '/',
'/bonduelletv/la-poltiglia-bordolese/' : '/',
'/bonduelletv/la-potatura-dei-lamponi/' : '/',
'/bonduelletv/la-preparazione-del-terreno-la-concimazione-fondo/' : '/',
'/bonduelletv/la-preparazione-del-terreno-la-concimazione-fondo/?amp' : '/',
'/bonduelletv/la-raccolta-della-zucca/' : '/',
'/bonduelletv/larrivo-della-materia-allo-stabilimento/' : '/',
'/bonduelletv/la-semina-dei-fagiolini-nani/' : '/',
'/bonduelletv/la-semina-dellaglio/' : '/',
'/bonduelletv/la-semina-della-zucca/' : '/',
'/bonduelletv/la-semina-dellokra/' : '/',
'/bonduelletv/la-sfemminellatura-dei-pomodori/' : '/',
'/bonduelletv/le-coccole/' : '/',
'/bonduelletv/legacci-naturali-salici/' : '/',
'/bonduelletv/linzaffardatura-o-zaffardatura-preparare-la-piantagione-degli-alberi-radice-nuda/' : '/',
'/bonduelletv/lorto-vaso/' : '/',
'/bonduelletv/maionese-avocado-chips-platano-tocco-mais/' : '/',
'/bonduelletv/marco-nicola-insalata/' : '/',
'/bonduelletv/melanzane-patate-varieta/' : '/',
'/bonduelletv/mini-aspic-arcobaleno-ricetta/' : '/',
'/bonduelletv/muffin-mais-prosciutto-cotto-formaggio/' : '/',
'/bonduelletv/nunzio-coltivare/' : '/',
'/bonduelletv/orti-dipinti-costruire-strutture-bambu-lorto/' : '/',
'/bonduelletv/orti-dipinti-giocare-semi-nellorto/' : '/',
'/bonduelletv/orti-dipinti-lerba-della-madonna/' : '/',
'/bonduelletv/orto-cassone-metodi-irrigazione/' : '/',
'/bonduelletv/orto-cassone-terra-concimazione/' : '/',
'/bonduelletv/orto-terrazzo-abbinare-le-piante/' : '/',
'/bonduelletv/orto-terrazzo-fiori-utili/' : '/',
'/bonduelletv/orto-terrazzo-terra-irrigazione/' : '/',
'/bonduelletv/padellata-calda-ceci-spinaci-millefoglie-bonduelle/' : '/',
'/bonduelletv/panino-cotoletta-lenticchie-bonduelle/' : '/',
'/bonduelletv/panissa-vercellese-borlotti-bonduelle/' : '/',
'/bonduelletv/passione-lorenzo/' : '/',
'/bonduelletv/pasta-farro-integrale-tonno-verdure-alla-curcuma/' : '/',
'/bonduelletv/pasticcio-spiato-piselli-cavolfiori-bonduelle/' : '/',
'/bonduelletv/perche-utilizzare-cippato-ramaglie-fresche/' : '/',
'/bonduelletv/piadina-mista-fine-piselli-bonduelle/' : '/',
'/bonduelletv/piantagione-patate/' : '/',
'/bonduelletv/piselli-taccole-crumble-pane-al-limone/' : '/',
'/bonduelletv/pizza-mais-olive-peperoni-tonno-mista-fine-bonduelle/' : '/',
'/bonduelletv/plumcake-bettelmatt-tocco-soia-edamame/' : '/',
'/bonduelletv/plumcake-salato-mais-piselli-accompagnato-icebergcarote-bonduelle/' : '/',
'/bonduelletv/polenta-tazza-funghi-tocco-ceci/' : '/',
'/bonduelletv/pomodori-del-giardino-castel-ruggero/' : '/',
'/bonduelletv/pomodori-ripieni-couscous-mais-zucchine-provola/' : '/',
'/bonduelletv/quali-varieta-zucca-coltivare-farle-crescere/' : '/',
'/bonduelletv/qualunque-sia-la-tua-idea-cena-romantica/' : '/ricette',
'/bonduelletv/qualunque-sia-la-tua-idea-pranzo-famiglia/' : '/ricette',
'/bonduelletv/quattro-consigli-affrontare-la-stramilano/' : '/',
'/bonduelletv/quiche-salata/' : '/',
'/bonduelletv/realizzare-talea-di-rosmarino/' : '/',
'/bonduelletv/realizzare-un-orto-cassone/' : '/',
'/bonduelletv/ribollita-cannellini-bonduelle/' : '/',
'/bonduelletv/riccia-radicchio-peperoni-mais-bonduelle-fichi-caramellati-al-forno/' : '/',
'/bonduelletv/ricetta-insalata-duetto-dolce-bonduelle/' : '/ricette',
'/bonduelletv/ricetta-insalata-rinforzo-le-insalatine-degli-agricoltori-bonduelle/' : '/ricette',
'/bonduelletv/ricetta-involtini-di-pollo-provola/' : '/ricette',
'/bonduelletv/ricetta-peperoni-gratinati-forno-ripieni-mais/' : '/ricette',
'/bonduelletv/rolle-prosciutto-insalata-russa-leggera/' : '/ricette',
'/bonduelletv/rucola-carote-polpette-pollo-ricotta-piselli-bonduelle/' : '/ricette',
'/bonduelletv/rucola-carote-polpette-pollo-ricotta-piselli-bonduelle-2/' : '/ricette',
'/bonduelletv/semenzaio-parte/' : '/',
'/bonduelletv/semenzaio-seconda-parte/' : '/',
'/bonduelletv/semina-spinacio-invernale/' : '/',
'/bonduelletv/sformatini-piselli-tenere-insalatine/' : '/ricette',
'/bonduelletv/sformatino-spinaci-champignon-iceberg-carote/' : '/ricette',
'/bonduelletv/sformato-di-patate-mais/' : '/ricette',
'/bonduelletv/sostenibilita-impatto-ambientale/' : '/',
'/bonduelletv/spiedini-pesce-spada-primizie-stagione-bonduelle/' : '/ricette',
'/bonduelletv/spinaci-borlotti-aromatici/' : '/ricette',
'/bonduelletv/spinaci-lenticchie-allarancia-mandorle/' : '/ricette',
'/bonduelletv/stelle-spinaci-vapore-fagiolini-bonduelle/' : '/ricette',
'/bonduelletv/strudel-salato-ratatouille/' : '/ricette',
'/bonduelletv/supporto-fagiolini-rampicanti/' : '/',
'/bonduelletv/tacos-pollo-mais-olive-peperoni-bonduelle/' : '/ricette',
'/bonduelletv/tartelletta-fagiolini-patate/' : '/ricette',
'/bonduelletv/tortino-caco-zola-patate-tocco-soia-edamame/' : '/ricette',
'/bonduelletv/trapianto-pomodoro/' : '/',
'/bonduelletv/tyropita-spinaci-millefoglie-armonia-bonduelle/' : '/ricette',
'/bonduelletv/uova-alla-benedict-fili-gustosi-funghi-champignon/' : '/ricette',
'/bonduelletv/vellutata-zucchine-spinaci-fagiolini-focaccia-ai-formaggi-insalata-primavera-bonduelle/' : '/ricette',
'/bonduelletv/video-esempio-percorso-qualita/' : '/',
'/bonduelletv/videoricetta-focaccine-fagioli-rossi/' : '/ricette',
'/bonduelle-tv-video/' : '/',
'/bonduelle-tv-video/a-spasso-nell-orto/' : '/',
'/bonduelle-tv-video/a-spasso-nell-orto/page/2/' : '/',
'/bonduelle-tv-video/a-spasso-nell-orto/page/3/' : '/',
'/bonduelle-tv-video/a-spasso-nell-orto/page/4/' : '/',
'/bonduelle-tv-video/cook-learn/' : '/',
'/bonduelle-tv-video/cook-learn/page/2/' : '/',
'/bonduelle-tv-video/dal-fatto-al-piatto/' : '/',
'/bonduelle-tv-video/dal-fatto-al-piatto/page/2/' : '/',
'/bonduelle-tv-video/dal-fatto-al-piatto/page/3/' : '/',
'/bonduelle-tv-video/idee-contorni/' : '/',
'/bonduelle-tv-video/il-buon-paese/' : '/',
'/bonduelle-tv-video/i-love-mais/' : '/',
'/bonduelle-tv-video/il-tuo-tocco/' : '/',
'/bonduelle-tv-video/i-nostri-spot/' : '/',
'/bonduelle-tv-video/la-via-della-freschezza/' : '/',
'/bonduelle-tv-video/scendiamo-in-campo/' : '/',
'/bonduelle-tv-video/scendiamo-in-campo/page/2/' : '/',
'/bonduelle-tv-video/verdure-sport/' : '/veggie-passion/veggie-passion',
'/buonisconto' : '/promozioni',
'/categoria/comunicazione/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/page/2/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/page/3/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/page/4/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/page/5/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/page/6/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/page/7/' : '/azienda/novita',
'/categoria/comunicazione/comunicati-stampa/page/8/' : '/azienda/novita',
'/categoria/comunicazione/spot-tv/' : '/',
'/categoria/concorso/' : '/promozioni',
'/categoria/cookblog/' : '/veggie-passion/veggie-passion',
'/categoria/cookblog/blog/bambini-e-verdure/' : '/ricette',
'/categoria/cookblog/blog/cucina_famiglia/' : '/ricette',
'/categoria/cookblog/blog/il-buono-della-tradizione/' : '/ricette-di-cucina',
'/categoria/cookblog/blog/le-vostre-ricette/' : '/ricette',
'/categoria/cookblog/blog/page/2/' : '/veggie-passion/veggie-passion',
'/categoria/cookblog/blog/schiscetta-creativa/' : '/ricette',
'/categoria/cookblog/blog/schiscetta-creativa/page/2/' : '/ricette',
'/categoria/cookblog/blog/verdure-e-sport/' : '/veggie-passion/veggie-passion',
'/categoria/cookblog/il-tuo-tocco/' : '/ricette-di-cucina',
'/categoria/cookblog/il-tuo-tocco/page/2/' : '/ricette-di-cucina',
'/categoria/cookblog/vegetal-news/' : '/veggie-passion/alimentazione-curiosita',
'/categoria/cookblog/vegetal-news/page/2/' : '/veggie-passion/alimentazione-curiosita',
'/categoria/cookblog/vegetal-news/page/3/' : '/veggie-passion/alimentazione-curiosita',
'/categoria/cookblog/vegetal-news/page/4/' : '/veggie-passion/alimentazione-curiosita',
'/categoria/cookblog/vegetal-news/page/5/' : '/veggie-passion/alimentazione-curiosita',
'/categoria/cookblog/vegetal-news/page/6/' : '/veggie-passion/alimentazione-curiosita',
'/categoria/cookblog/vegetal-news/page/7/' : '/veggie-passion/alimentazione-curiosita',
'/categoria/lavora-con-noi/' : '/lavora-con-noi',
'/categoria/ricettari/' : '/ricette-di-cucina',
'/categoria/verdure/' : '/azienda/abc-verdure',
'/categoria/verdure/page/2/' : '/azienda/abc-verdure',
'/categoria/verdure/page/3/' : '/azienda/abc-verdure',
'/categoria/verdure/page/4/' : '/azienda/abc-verdure',
'/coccole_falafel' : '/ricette',
'/coccole-falafel/' : '/ricette',
'/completa-questionario/' : '/contatto',
'/comunicazione/comunicati-stampa/agitagusta-bonduelle-unofferta-completa-pausa-pranzo-sempre-ricca-novita/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/allegrie-mais-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/allegrie-mais-bonduelle-i-mix-mais-verdure-cotti-al-vapore-cosi-appetitosi-leggeri-far-sorridere-piatto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/benvenuta-estate-inpausa-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-agitagusta-il-pack-ecosostenibile-il-piacere-dellinsalata-piu-leggero/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-alvin-3-si-salvi-chi-puo/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-lancia-agitagusta-nuovo-pack-eco-sostenibile/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-lancia-i-burger-bio-piacere-100-vegetale/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-gusto-fantasia-la-nuova-gamma-che-porta-colore-allegria-cucina/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-iceberg-carote-freschezza-croccantezza-unico-mix-insalata/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-i-piselli-cuore-raccolto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-la-nuova-gamma-agitagusta-nuovi-ingredienti-mix-inediti-unofferta-piu-completa-pausa-pranzo-sempre-ricca-novita/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-la-nuova-gamma-le-insalatine-degli-agricoltori/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-la-nuova-gamma-primizie-stagione/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-la-nuova-ratatouille/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-le-nuove-lenticchie-al-vapore-cottura-piu-delicata-verdure-legumi-danno-il-meglio-tavola/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-mais-olive-peperoni/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-sapore-destate/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-presenta-trivoglio-nuova-ricetta-piu-gustosa/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-propone-coccole-deliziosi-tortini-verdure-subito-pronti-gustare/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-propone-fagiolini-patate-natura-padella-appetitoso-mix-verdure-subito-pronto-gustare/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-propone-le-cereallegre-tre-nuove-ricette-perfette-linverno/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-propone-mama-mama-foglie-intere-tenere-dal-cuore-croccante/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-propone-tavola-la-nuova-linea-insalate-le-selezioni-realizzata-insieme-ai-propri-consumatori/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-sponsor-della-46-edizione-della-stramilano/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-sponsor-del-rome-model-united-nations-2012-2/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-vapore-spinaci-gli-spinaci-cotti-vapore-pronti-sei-minuti/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/bonduelle-vinci-premio-al-giorno-100-giorni-palio-100-collier-oro-bianco-perla-diamante-fiat-500-cabrio-twinair/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/ceci-cuore-raccolto-cotti-al-vapore-bonduelle-2/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/ceci-cuore-raccolto-cotti-al-vapore-bonduelle-3/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/ceci-cuore-raccolto-cotti-al-vapore-bonduelle-4/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/classico-portare-tavola-natale-capodanno-lenticchie-al-vapore/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/concorso-natura-padella/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/condi-o-cuoci-bonduelle-i-nuovi-originali-mix-insalata-verdure-scatenare-la-fantasia-cucina/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/fagioli-borlotti-fagioli-cannellini-bonduelle-cuore-raccolto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/fagiolini-bonduelle-il-gusto-la-semplicita-il-verde-brillante-della-natura-che-rinfresca-lestate/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/fagiolini-fini-ed-extra-fini-cuore-raccolto-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/fagioli-rossi-bonduelle-unidea-gustosa-originale-abbinamenti-dal-sapore-etnico/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/fave-cotte-al-vapore-bonduelle-dal-cuore-del-raccolto-prodotto-gustoso-genuino-2/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/funghi-champignon-tagliati-cotti-al-vapore-cuore-raccolto-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/germogli-soia-bonduelle-originalita-leggerezza-benessere/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/gli-insiemi-gustosi-bonduelle-lenticchie-farro-carote-piselli-mix-originale-arricchire-le-tue-ricette-stagione/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/i-germogli-bonduelle-tocco-creativita-cucina-dare-vita-tante-nuove-ricette-gustose-leggere/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/i-mix-creativi-pronti-condire-contorni-leggeri-gustose-insalatone/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/la-gamma-primizie-stagione-bonduelle-eletta-prodotto-dellanno-2015/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/la-nuova-insalata-armonia-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/le-insalate-il-mais-bonduelle-vinci-gardaland/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/le-julienne-bonduelle-i-fili-croccanti-leggeri-gustosi-che-uniscono-piacere-benessere-praticita/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/le-julienne-bonduelle-ispirazione-fantasia-uninsalata-sempre-appetitosa/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/le-nostre-promozioni/' : '/promozioni',
'/comunicazione/comunicati-stampa/lenticchie-cuore-raccolto-cotte-al-vapore-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/lenticchie-cuore-raccolto-cotte-al-vapore-bonduelle-lingrediente-giusto-il-menu-natalema-2/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/lenticchie-farro-carote-piselli-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/le-zuppe-estive-il-gusto-autentico-delle-verdure/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-allegrie-mais-bonduelle-i-chicchi-dorati-croccanti-del-mais-si-sposano-i-migliori-mix-verdure-far-sorridere-piatto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-bonduelle-chicchi-dorati-croccanti-cotti-al-vapore/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-bonduelle-chicchi-dorati-croccanti-cotti-al-vapore-che-aggiungono-tocco-allegria-ad-piatto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-bonduelle-chicchi-dorati-croccanti-ideali-preparare-appetitose-ricette-caldo/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-bonduelle-colore-gusto-fantasia-arricchire-le-tue-insalatone/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-bonduelle-i-chicchi-dorati-croccanti-del-mais-si-sposano-i-migliori-mix-verdure-far-sorridere-piatto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-bonduelle-i-chicchi-dorati-croccanti-naturalmente-dolci-che-aggiungono-tocco-allegria-ad-piatto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/mais-bonduelle-unestate-ricca-nuovi-gustosi-mix/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/novita-i-surgelati-bonduelle-natura-padella-mais-carote-fagiolini/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/novita-nel-banco-frigo-bonduelle-lancia-la-carta-delle-insalate/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/nuova-linea-al-vapore-bonduelle-cottura-piu-delicata-verdure-legumi-danno-il-meglio-tavola/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/nuova-ratatouille-bonduelle-il-buono-del-tradizionale-mix-verdure-subito-pronto-gustare-nel-pratico-pack-scrigno/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/nuove-cereallegre-senza-glutine-due-sfiziose-novita-arricchire-gusto-la-pausa-pranzo-estiva/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/nuove-lenticchie-cuore-raccolto-cotte-al-vapore-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/nuovi-insiemi-gustosi-bonduelle/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/shopping-bonduelle-vinci-buono-acquisto-al-giorno-120-giorni-100e-partecipi-allestrazione-finale-5-superpremi-1000e/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/spinaci-millefoglie-bonduelle-porta-tavola-selezione-foglie-tenere-dal-sapore-intenso-raccolte-surgelate-giornata-preservare-qualita-gusto/' : '/azienda/novita',
'/comunicazione/comunicati-stampa/vinci-gardaland-bonduelle/' : '/azienda/novita',
'/comunicazione/spot-tv/bonduelle-presenta-cotto-al-vapore/' : '/',
'/comunicazione/spot-tv/insalatine-degli-agricoltori/' : '/',
'/comunicazione/spot-tv/le-coccole/' : '/',
'/comunicazione/spot-tv/qualunque-sia-la-tua-idea-cena-romantica/' : '/',
'/comunicazione/spot-tv/qualunque-sia-la-tua-idea-pranzo-famiglia/' : '/ricette',
'/comunicazione/spot-tv/spot-tv-promozione-gardaland-2012/' : '/',
'/concorso/concorso-orti-per-larte-partecipa/' : '/promozioni',
'/concorso/insalatine-bonduelle/' : '/promozioni',
'/concorso/insalatine-bonduelle-2016/' : '/promozioni',
'/concorso/vinci-disney-bonduelle-partecipa-subito/' : '/promozioni',
'/concorso/vinci-la-vacanza-dei-tuoi-sogni/' : '/promozioni',
'/concorso-insalatine-bonduelle-2016/' : '/promozioni',
'/concorso-orti-per-larte/' : '/promozioni',
'/contatta/' : '/contatto',
'/cookblog/blinis-mediterraneo/' : '/ricette',
'/cookblog/blog/bambini-e-verdure/crema-mais/' : '/ricette/r/crema-di-mais-natalizia/itgp159',
'/cookblog/blog/bambini-e-verdure/focaccine-verdi-amore-mais-songino-bonduelle/' : '/ricette',
'/cookblog/blog/bambini-e-verdure/frittata-insalata-nel-cestino/' : '/ricette',
'/cookblog/blog/bambini-e-verdure/gnocchi-patate-piselli-julienne-zucchine/' : '/ricette',
'/cookblog/blog/bambini-e-verdure/quiche-iceberg-carote-bonduelle/' : '/ricette',
'/cookblog/blog/bambini-e-verdure/taccole-pomodoro-basilico/' : '/ricette',
'/cookblog/blog/bambini-e-verdure/torta-dolce-patate-piselli-mais-formaggio-mandorle/' : '/ricette',
'/cookblog/blog/bambini-e-verdure/vellutata-carotine-pois-verdi/' : '/ricette',
'/cookblog/blog/blogger-cucina/' : '/veggie-passion/veggie-passion',
'/cookblog/blog/cucina_famiglia/baccala-patate-croccanti-pate-olive-mais/' : '/ricette',
'/cookblog/blog/cucina_famiglia/cucina-famiglia-giovanna-nobile/' : '/ricette',
'/cookblog/blog/cucina_famiglia/gran-mix-gustoso-feta-olive-verdi-noci/' : '/ricette',
'/cookblog/blog/cucina_famiglia/le-tenere-insalatine-bonduelle-salmone-affumicato-chicchi-melagrana/' : '/ricette',
'/cookblog/blog/cucina_famiglia/minestrone-classico-bonduelle-pasta-alluovo-tipo-maltagliati-fatti-mano/' : '/ricette',
'/cookblog/blog/cucina_famiglia/mini-quiche-pasta-fillo-farcite-crema-alla-robiola-piselli-maggiorana/' : '/ricette',
'/cookblog/blog/cucina_famiglia/pate-fagioli-cannellini-prosciutto-crudo/' : '/ricette',
'/cookblog/blog/cucina_famiglia/polpettine-ricotta-spinaci-salsa-pomodoro-2/' : '/ricette',
'/cookblog/blog/cucina_famiglia/primavera-bonduelle-turbanti-sogliola-salsa-allo-yogurt/' : '/ricette',
'/cookblog/blog/cucina_famiglia/torta-salata-patate-fagiolini-bonduelle/' : '/ricette',
'/cookblog/blog/cucina_famiglia/vellutata-borlotti-prosciutto-crudo-saporito/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/caciocavallo-allargentiera/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/canederlo-verdure/' : '/ricette/r/canederli-di-verdure/itgp117',
'/cookblog/blog/il-buono-della-tradizione/cassoni-emiliani-insalatine/' : '/ricette/r/cassoni-emiliani-con-insalatine/itgp119',
'/cookblog/blog/il-buono-della-tradizione/fagioli-cannellini-salsa-licurdia-calabrese/' : '/ricette/r/fagioli-cannellini-con-salsa-licurdia-calabrese/itgp116',
'/cookblog/blog/il-buono-della-tradizione/fagiolini-alla-fiorentina/' : '/ricette/r/fagiolini-alla-fiorentina/itgp121',
'/cookblog/blog/il-buono-della-tradizione/fricandeau-valdostano-manzo-trivoglio-bonduelle/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/frisella-pugliese-insalata/' : '/ricette/r/frisella-pugliese-con-insalata/itgp122',
'/cookblog/blog/il-buono-della-tradizione/ghiotta-abruzzese/' : '/ricette/r/ghiotta-abbruzzese/itgp123',
'/cookblog/blog/il-buono-della-tradizione/giardiniera-piemontese/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/il-buono-della-tradizione-alessandra-giovanile/' : '/ricette-di-cucina',
'/cookblog/blog/il-buono-della-tradizione/insalata-rinforzo-campana/' : '/ricette/r/insalata-di-rinforzo-campana/itgp114',
'/cookblog/blog/il-buono-della-tradizione/jota-friulana/' : '/ricette/r/jota-friulana/itgp118',
'/cookblog/blog/il-buono-della-tradizione/minestrone-la-fregula/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/sogliole-saor-mix-armonia-bonduelle-salsa-veneta/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/taroz-valtellinesi/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/testaroli-liguri-alla-crema-parmigiano-fili-gustosi/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/torta-dolce-salata-della-basilicata/' : '/ricette/r/torta-dolce-salata-lucana/itgp120',
'/cookblog/blog/il-buono-della-tradizione/tortino-marchigiano-alici-patate/' : '/ricette',
'/cookblog/blog/il-buono-della-tradizione/zuppa-lenticchie-farro-carote-piselli-bonduelle-castagne-alla-montanara/' : '/ricette/r/zuppa-di-lenticchie-farro-carote-e-piselli/itgp021',
'/cookblog/blog/il-buono-della-tradizione/zuppa-umbra-cereali-legumi/' : '/ricette/r/zuppa-umbra-di-cereali-e-legumi/itgp115',
'/cookblog/blog/le-vostre-ricette/baccala-bassa-temperatura-polvere-prosciutto/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/burger-piselli/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/calamaro-piselli-primavera/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/cannoli-primavera/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/ciambella-rustica-naturalmente-dolce/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/cocottine-fiorite/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/cous-cous-pisellini-pomodorini-persona/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/dolce-goloso/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/fantasia-flan/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/finta-carbonara-piselli-fave-persona/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/green-cake/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/insalata-riso-venere-primaverile-take-away/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/lasagne-croccanti-pesce/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/piatto-italy/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/polpettine-ricotta-crema-piselli/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/polpettine-saporite-crema-avocado/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/spiedini-gamberi-speck-couscous-tricolore/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/spiedini-gamberi-vellutata-piselli/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/tagliatelle-alla-menta-piselli-glassa-rossa/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/torta-soffio-primavera/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/tricolore-italian-style/' : '/ricette',
'/cookblog/blog/le-vostre-ricette/uovo-poche-crema-piselli-yogurt-mandorle/' : '/ricette',
'/cookblog/blog/ricette-borlotti/' : '/ricette',
'/cookblog/blog/ricette-broccoli/' : '/ricette',
'/cookblog/blog/ricette-cannellini/' : '/ricette',
'/cookblog/blog/ricette-carote/' : '/ricette',
'/cookblog/blog/ricette-cavolfiore/' : '/ricette',
'/cookblog/blog/ricette-ceci/' : '/ricette',
'/cookblog/blog/ricette-con-asparagi/' : '/ricette',
'/cookblog/blog/ricette-fagiolini/' : '/ricette',
'/cookblog/blog/ricette-fagioli-rossi/' : '/ricette',
'/cookblog/blog/ricette-fave/' : '/ricette',
'/cookblog/blog/ricette-finocchi/' : '/ricette',
'/cookblog/blog/ricette-funghi-champignon/' : '/ricette',
'/cookblog/blog/ricette-iceberg/' : '/ricette',
'/cookblog/blog/ricette-lattuga/' : '/ricette',
'/cookblog/blog/ricette-lenticchie/' : '/ricette',
'/cookblog/blog/ricette-patate/' : '/ricette',
'/cookblog/blog/ricette-rucola/' : '/ricette',
'/cookblog/blog/ricette-songino/' : '/ricette',
'/cookblog/blog/ricette-spinaci/' : '/ricette',
'/cookblog/blog/ricette-taccole/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/cous-cous-allo-zafferano-ceci-gamberetti/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/insalata-alla-cantonese/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/insalata-ananas-grigliato/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/insalata-asiatica/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/insalata-estiva/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/insalata-zucchine/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/pasta-fredda-pugliese/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/polpette-lenticchie-sesamo-al-forno/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/rotolo-frittata-farcito/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/schiscetta-creativa-barbara-tauscheck/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/sushi-pane-cannellini-carote/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/tortillas-pollo/' : '/ricette',
'/cookblog/blog/schiscetta-creativa/tortino-ricotta-spinaci/' : '/ricette',
'/cookblog/blog/verdure-e-sport/insalata-riso-integrale-rosso-quinoa-verdure-mandorle-al-profumo-darancia/' : '/veggie-passion/veggie-passion',
'/cookblog/blog/verdure-e-sport/la-cena-perfetta-post-gara-amiche/' : '/veggie-passion/veggie-passion',
'/cookblog/blog/verdure-e-sport/muffin-salati-farina-integrale-verdure/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/blog/verdure-e-sport/pasta-farro-integrale-tonno-verdure-alla-curcuma/' : '/veggie-passion/veggie-passion',
'/cookblog/blog/verdure-e-sport/quattro-consigli-run-like-never-before-affrontare-la-stramilano/' : '/veggie-passion/veggie-passion',
'/cookblog/blog/verdure-e-sport/tortilla-wrap-verdure-avocado-yogurt-allerba-cipollina/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/il-tuo-tocco/il-tuo-tocco-a-carnevale/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-a-carnevale/null' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-al-lavoro/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-a-pasqua/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-a-pasquetta/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-a-san-valentino/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-per-il-papa/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-per-le-donne/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/il-tuo-tocco-per-un-brunch/' : '/ricette-di-cucina',
'/cookblog/il-tuo-tocco/loriginalita-tavola-riso-integrale-feta-tocco-soia-edamame/' : '/ricette/r/riso-integrale-con-feta-e-soia-edamame/itgp088',
'/cookblog/il-tuo-tocco/reinterpretare-un-classico-curry-vegetariano-zucca-tocco-ceci/' : '/ricette',
'/cookblog/il-tuo-tocco/ricetta-perfetta-un-pranzo-amiche-mini-tigelle-squacquerone-tocco-ceci/' : '/ricette',
'/cookblog/il-tuo-tocco/stupire-semplicita-mini-cheesecake-salate-aromatizzate-alla-menta/' : '/ricette/r/mini-cheesecake-salata-aromatizzata-alla-menta-con-ceci/itgp091',
'/cookblog/pesto-rucola-carote/' : '/ricette',
'/cookblog/polpettine-lenticchie-farro/' : '/ricette',
'/cookblog/ricette-con-mais/' : '/ricette',
'/cookblog/ricette-con-piselli/' : '/ricette',
'/cookblog/ricette-con-zucchine/' : '/ricette',
'/cookblog/rosti-patate-stelle-filanti-fili-gustosi/' : '/ricette',
'/cookblog/vegetal-news/aglio-germogliato-fa-meglio/' : '/veggie-passion/articolo/aglio-germogliato-proprieta-benefici/2067/2067',
'/cookblog/vegetal-news/aglio-nero-vantaggi-proprieta-benefici/' : '/azienda/abc-verdure/aglio-nero-proprieta-benefici-usi-in-cucina/2051/2051',
'/cookblog/vegetal-news/albero-natale-illuminato-dai-cavolini-bruxelles/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/asma-ko-le-verdure/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/batteri-ko-laglio/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/broccoli-cura-naturale-stress-alzheimer/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/cannella-spezia-proprieta/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/carota-del-fucino-igp/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/carote-proprieta-cucina/' : '/azienda/abc-verdure/carote-proprieta-benefici-usi-in-cucina/893/97',
'/cookblog/vegetal-news/cavolfiore-che-si-crede-broccolo/' : '/veggie-passion/articolo/broccolo-di-bassano-proprieta-benefici-usi-in-cucina/2065/2065',
'/cookblog/vegetal-news/cavolo-che-panorama/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/chia-semi-in-cucina/' : '/veggie-passion/articolo/semi-da-mangiare-varieta-utilizzi/2064/2064',
'/cookblog/vegetal-news/cibi-cuore-sano/' : '/veggie-passion/articolo/cibi-che-fanno-bene-al-cuore/2066/2066',
'/cookblog/vegetal-news/cibi-estate-salute/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/cina-verdura-al-guinzaglio/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/cookblogvegetal-newsceci-neri-proprieta-storia-cucina/' : '/azienda/abc-verdure/ceci-neri-proprieta-benefici-usi-in-cucina/2053/2053',
'/cookblog/vegetal-news/cottura-vapore-consigli-cucinare-verdure/' : '/veggie-passion/articolo/modalita-cottura-come-cuocere-al-vapore-le-verdure/2068/2068',
'/cookblog/vegetal-news/dessert-verdure/' : '/veggie-passion/articolo/dolci-salati-con-verdure/2072/2072',
'/cookblog/vegetal-news/dieta-equilibrata-gravidanza-aiuta-salute-bambino/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/difendervi-ci-pensano-i-broccoli/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/discorsi-piante/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/expo-2015-milano-orto-duomo/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/fagiolini-ricette-proprieta/' : '/azienda/abc-verdure/fagiolini-proprieta-benefici-usi-in-cucina/1640/1640',
'/cookblog/vegetal-news/fave-fanno-bene-salute-motivi-mangiarle/' : '/veggie-passion/articolo/mangiare-fave-benefici/2021/2021',
'/cookblog/vegetal-news/fave-proprieta/' : '/azienda/abc-verdure/fave-proprieta-benefici-usi-in-cucina/2079/2079',
'/cookblog/vegetal-news/festival-giganti/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/foody-mascotte-ufficiale-expo-2015-milano/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/frutta-verdura-gravidanza-fa-bene-bambino/' : '/veggie-passion/articolo/frutta-verdure-in-gravidanza/2022/2022',
'/cookblog/vegetal-news/frutta-verdura-migliorano-occhi-vista/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/funghi-che-nascono-dal-caffe/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/i-bambini-le-verdure-questione-distinto/' : '/veggie-passion/articolo/come-far-mangiare-verdure-ai-bambini/2073/2073',
'/cookblog/vegetal-news/i-broccoli-fanno-bene-anche-alle-ossa/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/il-colore-della-carota-viola/' : '/veggie-passion/articolo/carote-viola-proprieta-benefici-usi-in-cucina/840/840',
'/cookblog/vegetal-news/i-legumi-piccoli-tesori/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/il-mais-luomo-amore-che-dura-quasi-9000-anni/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/insalata-olio-oliva-ricetta/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/lappetito-vien-giocando/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/lappetito-vien-impiattando/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/la-sagra-del-fagiolo-controne/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/leggenda-topinambur/' : '/veggie-passion/articolo/cos-e-il-topinambur-storia-e-leggenda/2070/2070',
'/cookblog/vegetal-news/lenticchie-rosse-proprieta/' : '/azienda/abc-verdure/lenticchie-rosse-proprieta-benefici-usi-in-cucina/2052/2052',
'/cookblog/vegetal-news/le-scarpe-che-si-piantano/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/le-verdure-fanno-bene-prova-piu/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/le-verdure-i-superpoteri-i-broccoli/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/mangiare-5-volte-giorno-frutta-e-verdura-migliora-salute/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/mondo-verdure/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/pak-choi-proprieta-utilizzi/' : '/azienda/abc-verdure/pak-choi-proprieta-benefici-usi-in-cucina/2054/2054',
'/cookblog/vegetal-news/pappa-svezzamento-verdure/' : '/veggie-passion/articolo/svezzamento-bambini-verdure/2025/2025',
'/cookblog/vegetal-news/piccoli-soldi-capodanno-le-lenticchie/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/ricette-bonduelle-verdure-bambini/' : '/ricette',
'/cookblog/vegetal-news/senti-che-verdura/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/soluzione-anti-smog-broccoli/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/stress-da-lavoro-combattilo-mangiando/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/treccia-record/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/umore-cibo-mangerai/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/unabbronzatura-perfetta-mangia-piu-verdura/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/un-capolavoro-di-verdura/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/verdure-che-si-coltivano-accellerando/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/verdure-mangiarle-crude-cotte/' : '/veggie-passion/articolo/verdura-cotta-o-cruda/2024/2024',
'/cookblog/vegetal-news/verdure-meglio-accompagnate-che-sole/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/verdure-misura/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/verdure-spaziali/' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/vitamina-c-agrumi-anche-verdure/' : '/veggie-passion/articolo/verdure-con-vitamina-c/2071/2071',
'/cookblog/vegetal-news/vivere-meglio-lungo-mangiare-frutta-verdura/' : '/veggie-passion/alimentazione-curiosita',
'/cookie-policy/' : '/privacy-policy',
'/cotti-al-vapore/' : '/azienda/la-nostra-filiera',
'/coupon' : '/promozioni',
'/difficolta-ricette/difficile/' : '/ricette',
'/difficolta-ricette/facile/' : '/ricette',
'/difficolta-ricette/facile/page/16/' : '/ricette',
'/disney-con-bonduelle-hai-vinto/' : '/promozioni',
'/disney-con-bonduelle-non-hai-vinto/' : '/promozioni',
'/docstore/agrofrais' : '/',
'/easylift/' : '/',
'/elenco-ristoranti/Italia/' : '/',
'/elenco-ristoranti/Italia/page/10/' : '/',
'/elenco-ristoranti/Italia/page/2/' : '/',
'/elenco-ristoranti/Italia/page/3/' : '/',
'/elenco-ristoranti/Italia/page/4/' : '/',
'/elenco-ristoranti/Italia/page/5/' : '/',
'/elenco-ristoranti/Italia/page/7/' : '/',
'/elenco-ristoranti/Italia/page/9/' : '/',
'/favoriamo-le-produzioni-locali-e-stagionali' : '/azienda/articolo/bonduelle-si-impegnafavoriamo-le-produzioni-locali-e-stagionali/758/181',
'/favoriamo-produzioni-locali-e-stagionali/' : '/azienda/articolo/bonduelle-si-impegnafavoriamo-le-produzioni-locali-e-stagionali/758/181',
'/favoriamo-produzioni-locali-e-stagionali-temp' : '/azienda/articolo/bonduelle-si-impegnafavoriamo-le-produzioni-locali-e-stagionali/758/181',
'/favoriamo-produzioni-locali-e-stagionali-temp/' : '/azienda/articolo/bonduelle-si-impegnafavoriamo-le-produzioni-locali-e-stagionali/758/181',
'/filiera-garantita/' : '/azienda/la-nostra-filiera',
'/fine-concorso.html' : '/promozioni',
'/food-service/' : '/',
'/garantiamo-un-ampia-offerta-di-prodotti-biologici/' : '/azienda/articolo/bonduelle-si-impegnagarantiamo-una-ampia-offerta-di-prodotti-biologici/1765/1765',
'/garantiamo-un-ampia-offerta-di-prodotti-biologici-temp' : '/azienda/articolo/bonduelle-si-impegnagarantiamo-una-ampia-offerta-di-prodotti-biologici/1765/1765',
'/garantiamo-un-ampia-offerta-di-prodotti-biologici-temp/' : '/azienda/articolo/bonduelle-si-impegnagarantiamo-una-ampia-offerta-di-prodotti-biologici/1765/1765',
'/germogli-filiera-controllata/' : '/azienda/la-nostra-filiera',
'/gliortiperlarte/' : '/',
'/home-temp/' : '/',
'/i_buoni_in_tavola/' : '/promozioni',
'/i-buoni-in-tavola/' : '/promozioni',
'/i-buoni-in-tavola/BB' : '/promozioni',
'/i-buoni-in-tavola/bonduelle.it' : '/promozioni',
'/i-buoni-in-tavola/coupon' : '/promozioni',
'/il-processo-produttivo/' : '/azienda/la-nostra-filiera',
'/il-tuo-tocco/' : '/il-tuo-tocco',
'/il-tuo-tocco-di-ceci-test/' : '/prodotti/p/il-tuo-tocco-di-ceci/03083681068146',
'/il-tuo-tocco-di-edamame-test/' : '/prodotti/p/il-tuo-tocco-di-soia-edamame/03083681079647',
'/il-tuo-tocco-di-mais-test/' : '/prodotti/p/il-tuo-tocco-di-mais/03083681068184',
'/il-tuo-tocco-di-quinoa-test/' : '/prodotti/p/il-tuo-tocco-di-quinoa/03083681085518',
'/il-tuo-tocco-new/' : '/il-tuo-tocco',
'/il-tuo-tocco-test/' : '/il-tuo-tocco',
'/i-nostri-agricoltori-e-le-loro-storie/' : '/azienda/novita',
'/in-pausa/' : '/',
'/invia-la-tua-candidatura/' : '/lavora-con-noi',
'/invia-la-tua-ricetta/' : '/',
'/iscrizione-alla-newsletter/' : '/',
'/la-guida/' : '/',
'/le-cereallegre/' : '/prodotti',
'/le-insalate-degli-agricoltori/' : '/azienda/articolo/le-insalate-degli-agricoltori/1772/1772',
'/le-zuppe-bonduelle/' : '/ricette',
'/limitiamo-utilizzo-di-pesticidi/' : '/azienda/articolo/bonduelle-si-impegnalimitiamo-lo-utilizzo-di-pesticidi/872/129',
'/limitiamo-utilizzo-di-pesticidi-temp' : '/azienda/articolo/bonduelle-si-impegnalimitiamo-lo-utilizzo-di-pesticidi/872/129',
'/limitiamo-utilizzo-di-pesticidi-temp/' : '/azienda/articolo/bonduelle-si-impegnalimitiamo-lo-utilizzo-di-pesticidi/872/129',
'/mais-senza-residui-di-pesticidi' : '/mais-senza-residuo-di-pesticidi',
'/mais-senza-residuo-di-pesticidi/' : '/mais-senza-residuo-di-pesticidi',
'/naturainpadella/' : '/',
'/natura-in-padella/' : '/',
'/preserviamo-la-biodiversita-e-le-risorse-naturali/' : '/azienda/articolo/bonduelle-si-impegnapreserviamo-la-biodiversita-e-le-risorse-naturali/680/130',
'/preserviamo-la-biodiversita-e-le-risorse-naturali-temp' : '/azienda/articolo/bonduelle-si-impegnapreserviamo-la-biodiversita-e-le-risorse-naturali/680/130',
'/preserviamo-la-biodiversita-e-le-risorse-naturali-temp/' : '/azienda/articolo/bonduelle-si-impegnapreserviamo-la-biodiversita-e-le-risorse-naturali/680/130',
'/privacy/' : '/privacy-policy',
'/privacy-old' : '/privacy-policy',
'/prodotti/be-bio/le-insalate-be-bio/carote/' : '/prodotti/p/bebio-carote/08006862006794',
'/prodotti/be-bio/le-insalate-be-bio/insalatine-gustose/' : '/prodotti/p/bebio-insalatine-gustose/08006862006763',
'/prodotti/be-bio/le-insalate-be-bio/lattughino/' : '/prodotti/p/bebio-lattughino/08006862006756',
'/prodotti/be-bio/le-insalate-be-bio/mista-croccante/' : '/prodotti/bio',
'/prodotti/be-bio/le-insalate-be-bio/spinaci' : '/prodotti/p/bebio-spinaci/08006862006954',
'/prodotti/carta-delle-insalate/' : '/prodotti/insalate',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-capricciosa/attachment/cdi-ricetta-capricciosa-170/' : '/prodotti/insalate',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-deliziosa/' : '/prodotti/p/carta-delle-insalate-ricetta-deliziosa/08006862006206',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-fragrante/' : '/prodotti/p/carta-delle-insalate-ricetta-fragrante/08006862005605',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-gioiosa/' : '/prodotti/insalate',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-golosa/' : '/prodotti/insalate',
'/prodotti/carta-delle-insalate/cartadelleinsalate-ricettagustosa/' : '/prodotti/p/carta-delle-insalate-ricetta-gustosa/08006862002154',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-olive/' : '/prodotti/p/carta-delle-insalate-ricetta-olive/08006862006633',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-piccantina/' : '/prodotti/insalate',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-saporita/' : '/prodotti/p/carta-delle-insalate-ricetta-saporita/08006862006213',
'/prodotti/carta-delle-insalate/carta-delle-insalate-ricetta-vivace/' : '/prodotti/p/carta-delle-insalate-ricetta-vivace/08006862006183',
'/prodotti/carta-delle-insalate/prodotticarta-delle-insalatecarta-delle-insalate-ricetta-croccante/' : '/prodotti/p/carta-delle-insalate-ricetta-croccante/08006862006350',
'/prodotti/carta-delle-insalate/ricetta-limonetta/' : '/prodotti/p/carta-delle-insalate-ricetta-limonetta/08006862006602',
'/prodotti/categoria-prodotto%/tempura-di-verdure/' : '/prodotti/p/tempura-di-verdure/03083681079449',
'/prodotti/cereali-che-piacere/burger-bulgur-quinoa/' : '/prodotti/surgelati',
'/prodotti/cereali-che-piacere/burger-farro-amaranto/' : '/prodotti/surgelati',
'/prodotti/cereali-che-piacere/cous-cous/' : '/prodotti/surgelati',
'/prodotti/cereali-che-piacere/grano-saraceno-bulgur-quinoa/' : '/prodotti/surgelati',
'/prodotti/cereali-che-piacere/orzo-e-farro/' : '/prodotti/surgelati',
'/prodotti/cereali-che-piacere-conserve/mix-farro-pomodorini-olive-nere-capperi-semi-zucca/' : '/prodotti/p/cereali-che-piacere-farro/03083681092936',
'/prodotti/cereali-che-piacere-conserve/mix-orzo-farro-quinoa-rossa-edamame-lenticchie-fagioli-rossi/' : '/prodotti/p/cereali-che-piacere-orzo-farro-e-quinoa-rossa/03083681092929',
'/prodotti/fresco/le-regionali-ricetta-alla-ligure/' : '/prodotti/p/le-regionali-ricetta-alla-ligure/08006862007494',
'/prodotti/fresco/le-regionali-ricetta-alla-lombarda/' : '/prodotti/p/le-regionali-ricetta-alla-lombarda/08006862007319',
'/prodotti/fresco/le-regionali-ricetta-allamericana/' : '/prodotti/p/le-regionali-ricetta-all-americana/08006862007487',
'/prodotti/fresco/le-regionali-ricetta-alla-pugliese/' : '/prodotti/p/le-regionali-ricetta-alla-pugliese/08006862006701',
'/prodotti/fresco/le-regionali-ricetta-alla-sarda/' : '/prodotti/p/le-regionali-ricetta-alla-sarda/08006862006718',
'/prodotti/fresco/le-regionali-ricetta-alla-siciliana/' : '/prodotti/p/le-regionali-ricetta-alla-siciliana/08006862006732',
'/prodotti/fresco/le-regionali-ricetta-alla-trentina/' : '/prodotti/p/le-regionali-ricetta-alla-trentina/08006862006725',
'/prodotti/fresco/le-regionali-ricetta-alla-veneta/' : '/prodotti/piatti-pronti',
'/prodotti/fresco/linsalata-del-giorno-croccante' : '/prodotti/insalate',
'/prodotti/i-burger-bio/i-burger-bio-bulgur-ceci-peperoni-zucchine/' : '/prodotti/bio',
'/prodotti/i-burger-bio/i-burger-bio-bulgur-miglio-broccoli-pomodori-secchi/' : '/prodotti/bio',
'/prodotti/i-burger-bio/i-burger-bio-grano-saraceno-miglio-erbette-porri/' : '/prodotti/bio',
'/prodotti/i-burger-bio/i-burger-bio-miglio-orzo-melanzane-basilico/' : '/prodotti/bio',
'/prodotti/i-fagioli/borlotti-cotti-al-vapore/' : '/prodotti/p/borlotti-al-vapore/03083681003925',
'/prodotti/i-fagioli/borlotti-vetro-2/' : '/prodotti/p/borlotti-in-vetro/03083680020398',
'/prodotti/i-fagioli/cannellini-cotti-al-vapore/' : '/prodotti/p/cannellini-al-vapore/03083681003901',
'/prodotti/i-fagioli/cannellini-vetro/' : '/prodotti/p/cannellini-in-vetro/03083680020466',
'/prodotti/i-fagioli/fagioli-rossi-lattina-piccola/' : '/prodotti/p/fagioli-rossi-al-vapore/03083680045087',
'/prodotti/i-fagiolini/fagiolini-extra-fini-cotti-al-vapore/' : '/prodotti/p/fagiolini-extra-fini/03083680002219',
'/prodotti/i-fagiolini/fagiolini-fini-cotti-al-vapore/' : '/prodotti/p/fagiolini-fini/03083680026130',
'/prodotti/i-fagiolini/fagiolini-fini-tagliati-vetro-2/' : '/prodotti/conserve',
'/prodotti/i-fagiolini/prodottii-fagiolinifagiolini-fini-tagliati/' : '/prodotti/p/fagiolini-fini-tagliati/03083680037334',
'/prodotti/i-legumi/ceci-cotti-al-vapore/' : '/prodotti/p/ceci-al-vapore/03083681003949',
'/prodotti/i-legumi/ceci-vetro-2/' : '/prodotti/p/ceci-in-vetro/03083680016544',
'/prodotti/i-legumi/fave-cotte-al-vapore/' : '/prodotti/p/fave-al-vapore/03083681003888',
'/prodotti/i-legumi/germogli-lattina-piccola/' : '/prodotti/p/germogli/03083680020770',
'/prodotti/i-legumi/lenticchie-piccole-cotte-al-vapore/' : '/prodotti/p/lenticchie-piccole-al-vapore/03083681003963',
'/prodotti/i-legumi/lenticchie-piccole-cotte-al-vapore/consumo' : '/prodotti/p/lenticchie-piccole-al-vapore/03083681003963',
'/prodotti/i-legumi/taccole-tagliate/' : '/prodotti/p/taccole-tagliate/08410624107023',
'/prodotti/il-mais/mais/' : '/prodotti/p/mais/03083680025881',
'/prodotti/il-mais/mais-bio/' : '/prodotti/p/mais-bio/03083680996082',
'/prodotti/il-tuo-tocco/il-tocco-di-mais/' : '/prodotti/p/il-tuo-tocco-di-mais/03083681068184',
'/prodotti/il-tuo-tocco/il-tuo-tocco-di-ceci/' : '/prodotti/p/il-tuo-tocco-di-ceci/03083681068146',
'/prodotti/il-tuo-tocco/il-tuo-tocco-di-edamame/' : '/prodotti/p/il-tuo-tocco-di-soia-edamame/03083681079647',
'/prodotti/il-tuo-tocco/prodottiil-tuo-toccoil-tuo-tocco-di-quinoa/' : '/prodotti/p/il-tuo-tocco-di-quinoa/03083681085518',
'/prodotti/i-minestroni/gran-minestrone/' : '/prodotti/p/minestrone-ricco-con-passato/03083680510097',
'/prodotti/i-minestroni/minestrone-classico/' : '/prodotti/p/minestrone-classico/03083681043280',
'/prodotti/i-misti-a-base-di-mais/' : '/prodotti/conserve',
'/prodotti/i-misti-a-base-di-mais/mais-fagioli-rossi/' : '/prodotti/p/mais-e-fagioli-rossi/03083680978385',
'/prodotti/i-misti-a-base-di-mais/mais-olive-peperoni/' : '/prodotti/p/mais-olive-e-peperoni/03083681014051',
'/prodotti/i-misti-a-base-di-mais/mais-piselli/' : '/prodotti/p/mais-e-piselli/03083680915922',
'/prodotti/i-misti-di-verdure/broccoli-taccole-patate/' : '/prodotti/p/broccoli-taccole-e-patate/03083681067781',
'/prodotti/i-misti-di-verdure/carote-arancioni-e-gialle-taccole-e-pastinaca/' : '/prodotti/p/carote-arancioni-e-gialle-taccole-e-pastinaca/03083681107777',
'/prodotti/i-misti-di-verdure/fagiolini-patate/' : '/prodotti/p/fagiolini-e-patate/03083681019421',
'/prodotti/i-misti-di-verdure/mais-carote-fagiolini/' : '/prodotti/surgelati',
'/prodotti/i-misti-di-verdure/melanzane-zucchine-grigliate/' : '/prodotti/p/melanzane-e-zucchine-grigliate-con-carote-e-pomodori/03083681067798',
'/prodotti/i-misti-di-verdure/piselli-carotine-2/' : '/prodotti/p/piselli-e-carotine/03083680978170',
'/prodotti/i-misti-di-verdure/tris-cavoli-cavolfiori-broccoli-romanesco/' : '/prodotti/p/tris-di-cavoli/03083681032222',
'/prodotti/insalatedegliagricoltori/spinacino/' : '/prodotti/p/insalata-degli-agricoltori-spinacino/08006862007333',
'/prodotti/i-piatti-pronti/' : '/prodotti/piatti-pronti',
'/prodotti/i-piatti-pronti/delizia-spinaci/' : '/prodotti/p/delizia-di-spinaci/03083680886420',
'/prodotti/i-piatti-pronti/gratin-patate-spinaci/' : '/prodotti/p/gratin-di-patate-e-spinaci/03083681068368',
'/prodotti/i-piatti-pronti/le-coccole-broccoli-carote/' : '/prodotti/p/coccole-broccoli-e-carote/03083681116243',
'/prodotti/i-piatti-pronti/le-coccole-spinaci-fagiolini-broccoli/' : '/prodotti/p/coccole-spinaci-fagiolini-e-broccoli/03083681116274',
'/prodotti/i-piselli/piselli-bio/' : '/prodotti/p/piselli-bio/03083681079708',
'/prodotti/i-piselli/piselli-extra-fini-vetro/' : '/prodotti/p/piselli-extra-fini-in-vetro/03083680017121',
'/prodotti/i-piselli/piselli-fini-senza-zuccheri-aggiunti/' : '/prodotti/p/piselli-fini/03083681001471',
'/prodotti/i-piselli/piselli-finissimi/' : '/prodotti/p/piselli-finissimi/03083680026093',
'/prodotti/i-piselli/piselli-medi-senza-zuccheri-aggiunti/' : '/prodotti/p/piselli-medi/03083681001495',
'/prodotti/i-piselli/prodottii-pisellipiselli-finissimi-senza-zuccheri-aggiunti/' : '/prodotti/p/piselli-finissimi/03083680026093',
'/prodotti/i-ricettati-pronti/ratatouille/' : '/prodotti/p/ratatouille/03083681030891',
'/prodotti/i-surgelati-be-bio/bebio-minestrone/' : '/prodotti/p/bebio-minestrone/03083681092714',
'/prodotti/i-surgelati-be-bio/bebio-piselli/' : '/prodotti/p/bebio-piselli/03083681092820',
'/prodotti/le-altre-monoverdure/asparagi-verdi-vetro/' : '/prodotti/p/asparagi-verdi-in-vetro/08410624100123',
'/prodotti/le-altre-monoverdure/barbabietole-cubetti/' : '/prodotti/p/barbabietole-a-cubetti-al-vapore/03083681017656',
'/prodotti/le-altre-monoverdure/carote-fiammifero/' : '/prodotti/p/carote-a-fiammifero-al-vapore/03083681017687',
'/prodotti/le-altre-monoverdure/carotine-primizia-lattina-piccola/' : '/prodotti/p/carotine-primizia/03083680020732',
'/prodotti/le-altre-monoverdure/funghi-champignon-tagliati/' : '/prodotti/p/funghi-champignon/03083681014662',
'/prodotti/le-altre-monoverdure/spinaci-foglia/' : '/prodotti/p/spinaci-in-foglia/03083680026161',
'/prodotti/le-basi-per-cucinare/100-cavolfiore-in-forma-di-riso/' : '/prodotti/p/100-cavolfiore-in-forma-di-riso/03083681104325',
'/prodotti/le-basi-per-cucinare/spinaci-tritati/' : '/prodotti/p/spinaci-tritati/03083680019620',
'/prodotti/le-basi-per-cucinare/verdure-insalata-russa/' : '/prodotti/p/verdure-per-insalata-russa/03083680017626',
'/prodotti/le-cereallegre/' : '/prodotti/piatti-pronti',
'/prodotti/le-cereallegre/cous-cous-delizioso/' : '/prodotti/p/cereallegre-cous-cous-delizioso/08006862006091',
'/prodotti/le-cereallegre/fantasia-di-bulgur/' : '/prodotti/piatti-pronti',
'/prodotti/le-cereallegre/farro-alla-mediterranea-con-feta-dop/' : '/prodotti/p/cereallegre-farro-alla-mediterranea-con-feta-dop/08006862007456',
'/prodotti/le-cereallegre/insalata-di-riso/' : '/prodotti/piatti-pronti',
'/prodotti/le-cereallegre/mix-cereali-verdure/' : '/prodotti/p/cereali-che-piacere-orzo-farro-e-quinoa-rossa/03083681092929',
'/prodotti/le-cereallegre/orzo-con-tonno/' : '/prodotti/p/cereallegre-insalata-d-orzo-con-tonno/08006862006077',
'/prodotti/le-cereallegre/prodottile-cereallegrecous-cous-pollo-verdure/' : '/prodotti/p/cereallegre-cous-cous-con-pollo-e-verdure/08006862006084',
'/prodotti/le-cereallegre/riso-venere-sfizioso/' : '/prodotti/piatti-pronti',
'/prodotti/legumio/lenticchie-e-carote-in-forma-di-penne/' : '/prodotti/p/legumio-penne-di-lenticchie-e-carote/03083681080971',
'/prodotti/legumio/piselli-e-zucchine-in-forma-di-rigatoni/' : '/prodotti/p/legumio-rigatoni-di-piselli-e-zucchine/03083681081022',
'/prodotti/le-insalate-be-bio/prodottile-insalate-be-biobebio-mix-sfizioso/' : '/prodotti/p/bebio-mix-sfizioso/08006862006800',
'/prodotti/le-insalate-degli-agricoltori-bonduelle/' : '/prodotti/insalate',
'/prodotti/le-insalate-degli-agricoltori-bonduelle/insalata-di-lusia/' : '/prodotti/p/insalata-degli-agricoltori-insalata-di-lusia-igp/08006862007302',
'/prodotti/le-insalate-degli-agricoltori-bonduelle/la-rucola/' : '/prodotti/p/insalata-degli-agricoltori-rucola/08006862005933',
'/prodotti/le-insalate-degli-agricoltori-bonduelle/prodottile-insalatine-degli-agricoltori-bonduelleil-lattughino/' : '/prodotti/p/insalata-degli-agricoltori-lattughino/08006862005926',
'/prodotti/le-insalate-degli-agricoltori-bonduelle/prodottile-insalatine-degli-agricoltori-bonduelleil-songino/' : '/prodotti/p/insalata-degli-agricoltori-songino/08006862005957',
'/prodotti/le-insalate-degli-agricoltori-bonduelle/trio-freschezza/' : '/prodotti/p/insalata-degli-agricoltori-trio-freschezza/08006862005636',
'/prodotti/le-insalate-miste/' : '/prodotti/insalate',
'/prodotti/le-insalate-miste/armonia/' : '/prodotti/p/armonia/08006862005377',
'/prodotti/le-insalate-miste/gran-bis-rucola-songino/' : '/prodotti/insalate',
'/prodotti/le-insalate-miste/gran-mix-gustoso/' : '/prodotti/p/gran-mix-gustoso/08006862003816',
'/prodotti/le-insalate-miste/le-tenere-insalatine/' : '/prodotti/p/tenere-insalatine/03083680527842',
'/prodotti/le-insalate-miste/linsalata-del-giorno' : '/prodotti/p/insalata-del-giorno-tenere/08006862006367',
'/prodotti/le-insalate-miste/mista/' : '/prodotti/p/mista/03083680527736',
'/prodotti/le-insalate-miste/mista-dolce/' : '/prodotti/insalate',
'/prodotti/le-insalate-miste/mix-lattugoso/' : '/prodotti/p/mix-lattugoso/08006862005216',
'/prodotti/le-insalate-miste/mix-prezioso/' : '/prodotti/p/mix-prezioso/08006862005223',
'/prodotti/le-insalate-miste/mix-rucoloso/' : '/prodotti/p/mix-rucoloso/08006862005209',
'/prodotti/le-insalate-miste/songino-radicchio/' : '/prodotti/p/songino-e-radicchio/08006862003663',
'/prodotti/le-insalate-monovarieta/cuor-lattuga/' : '/prodotti/p/cuori-di-lattuga/03083680527750',
'/prodotti/le-insalate-monovarieta/iceberg/' : '/prodotti/p/iceberg/08006862003991',
'/prodotti/le-insalate-monovarieta/lattughino/' : '/prodotti/p/lattughino/03083680578936',
'/prodotti/le-insalate-monovarieta/rucola/' : '/prodotti/p/insalata-degli-agricoltori-rucola/08006862005933',
'/prodotti/le-insalate-monovarieta/songino/' : '/prodotti/p/insalata-degli-agricoltori-songino/08006862005957',
'/prodotti/le-insalatine-degli-agricoltori-bonduelle/la-rucola/' : '/prodotti/p/insalata-degli-agricoltori-rucola/08006862005933',
'/prodotti/le-insalatine-degli-agricoltori-bonduelle/le-insalatine/' : '/prodotti/insalate',
'/prodotti/le-monoverdure/carotine-primizia/' : '/prodotti/p/carotine-primizia/03083680009317',
'/prodotti/le-monoverdure/cavolini-bruxelles/' : '/prodotti/p/cavolini-di-bruxelles/03083680009379',
'/prodotti/le-monoverdure/fagiolini-extra-fini/' : '/prodotti/p/fagiolini-extra-fini/03083680918244',
'/prodotti/le-monoverdure/fagiolotti-verdi/' : '/prodotti/p/fagiolotti-verdi/03083680011075',
'/prodotti/le-monoverdure/piselli-extra-fini-2/' : '/prodotti/p/pisellini-extra-fini/03083681032215',
'/prodotti/le-monoverdure/piselli-novelli-fini/' : '/prodotti/p/piselli-novelli-fini/03083681024937',
'/prodotti/le-monoverdure/prodottile-monoverdurepiselli-extra-fini/' : '/prodotti/p/pisellini-extra-fini/03083681032215',
'/prodotti/le-monoverdure/taccole/' : '/prodotti/p/taccole/03083681042405',
'/prodotti/le-regionali/' : '/prodotti/piatti-pronti',
'/prodotti/le-regionali/le-regionali-ricetta-alla-greca/' : '/prodotti/piatti-pronti',
'/prodotti/le-regionali/le-regionali-ricetta-alla-norvegese/' : '/prodotti/piatti-pronti',
'/prodotti/le-selezioni/le-selezioni-lattughella/' : '/prodotti/insalate',
'/prodotti/le-selezioni/le-selezioni-mix-stagione/' : '/prodotti',
'/prodotti/le-spadellate/mix-gourmande/' : '/prodotti/p/mix-gourmande/03083681069877',
'/prodotti/le-spadellate/mix-rustico/' : '/prodotti/p/mix-rustico/03083681069846',
'/prodotti/le-verdure-a-foglia/biete-erbette-millefoglie/' : '/prodotti/p/biete-erbette-millefoglie/03083681042412',
'/prodotti/le-verdure-a-foglia/spinaci-millefoglie/' : '/prodotti/p/spinaci-millefoglie/03083681002621',
'/prodotti/le-verdure-da-cuocere/vapore-spinaci/' : '/prodotti/p/spinaci-in-foglia/03083680026161',
'/prodotti/mais-cereale/mais/' : '/prodotti/p/mais/03083680025881',
'/prodotti/mix-di-verdure/fantasia-verdure/' : '/prodotti/p/fantasia-di-verdure/03083680696982',
'/prodotti/mix-di-verdure/piselli-carotine/' : '/prodotti/p/piselli-e-carotine/03083680696968',
'/prodotti/mix-di-verdure/piselli-carotine-mais/' : '/prodotti/p/piselli-carotine-e-mais/03083680689786',
'/prodotti/mix-di-verdure/prodottimix-di-verdurelenticchie-farro-carote-piselli/' : '/prodotti/p/lenticchie-farro-carote-e-piselli/03083681021127',
'/prodotti/mix-di-verdure/trivoglio/' : '/prodotti/p/trivoglio/03083680702720',
'/prodotti/monovarieta/cuor-lattuga/' : '/prodotti/p/cuori-di-lattuga/03083680527750',
'/prodotti/monovarieta/gentilina/' : '/prodotti/p/gentilina/08006862007340',
'/prodotti/monovarieta/iceberg/' : '/prodotti/p/iceberg/08006862003991',
'/prodotti/monovarieta/lattughino/' : '/prodotti/p/lattughino/03083680578936',
'/prodotti/monovarieta/romana/' : '/prodotti/insalate',
'/prodotti/monovarieta/rucola/' : '/prodotti/p/insalata-degli-agricoltori-rucola/08006862005933',
'/prodotti/monovarieta/songino/' : '/prodotti/p/insalata-degli-agricoltori-songino/08006862005957',
'/prodotti/monovarieta/spinaci-pronti-cuocere/' : '/prodotti/p/spinaci/03083680567923',
'/prodotti-bonduelle' : '/prodotti',
'/prodotti-bonduelle/' : '/prodotti',
'/prodotti-bonduelle/be-bio/' : '/prodotti/bio',
'/prodotti-bonduelle/carta-delle-insalate/' : '/prodotti/insalate',
'/prodotti-bonduelle/cereali-che-piacere/' : '/prodotti/surgelati',
'/prodotti-bonduelle/cereali-che-piacere-conserve/' : '/prodotti/conserve',
'/prodotti-bonduelle/conserve/' : '/prodotti/conserve',
'/prodotti-bonduelle/conserve/page/2/' : '/prodotti/conserve',
'/prodotti-bonduelle/conserve/page/2/vendita' : '/prodotti/conserve',
'/prodotti-bonduelle/conserve/page/3/' : '/prodotti/conserve',
'/prodotti-bonduelle/conserve/page/4/' : '/prodotti/conserve',
'/prodotti-bonduelle/conserve/page/5/' : '/prodotti/conserve',
'/prodotti-bonduelle/fresco/' : '/prodotti/insalate',
'/prodotti-bonduelle/fresco/page/2/' : '/prodotti/insalate',
'/prodotti-bonduelle/fresco/page/3/' : '/prodotti/insalate',
'/prodotti-bonduelle/fresco/page/4/' : '/prodotti/insalate',
'/prodotti-bonduelle/fresco/page/5/' : '/prodotti/insalate',
'/prodotti-bonduelle/i-burger-bio/' : '/prodotti/bio',
'/prodotti-bonduelle/i-fagioli/' : '/prodotti/conserve',
'/prodotti-bonduelle/i-fagiolini/' : '/prodotti/conserve',
'/prodotti-bonduelle/i-legumi/' : '/prodotti/conserve',
'/prodotti-bonduelle/il-mais/' : '/prodotti/p/mais/03083680025881',
'/prodotti-bonduelle/il-tuo-tocco/' : '/prodotti/conserve',
'/prodotti-bonduelle/i-minestroni/' : '/prodotti/surgelati',
'/prodotti-bonduelle/i-misti-a-base-di-mais/' : '/prodotti/conserve',
'/prodotti-bonduelle/i-misti-di-verdure/' : '/prodotti/surgelati',
'/prodotti-bonduelle/i-piatti-pronti/' : '/prodotti/piatti-pronti',
'/prodotti-bonduelle/i-piselli/' : '/prodotti/conserve',
'/prodotti-bonduelle/i-ricettati-pronti/' : '/prodotti/conserve',
'/prodotti-bonduelle/i-surgelati-be-bio/' : '/prodotti/surgelati',
'/prodotti-bonduelle/le-agita-e-gusta/' : '/prodotti',
'/prodotti-bonduelle/le-altre-monoverdure/' : '/prodotti/conserve',
'/prodotti-bonduelle/le-basi-per-cucinare/' : '/prodotti/surgelati',
'/prodotti-bonduelle/le-cereallegre/' : '/prodotti/piatti-pronti',
'/prodotti-bonduelle/legumio/' : '/prodotti/pasta-legumi-verdure',
'/prodotti-bonduelle/le-insalate-be-bio/' : '/prodotti/bio',
'/prodotti-bonduelle/le-insalate-degli-agricoltori-bonduelle/' : '/prodotti/insalate',
'/prodotti-bonduelle/le-insalate-miste/' : '/prodotti/insalate',
'/prodotti-bonduelle/le-insalatine-degli-agricoltori-bonduelle/' : '/prodotti/insalate',
'/prodotti-bonduelle/le-julienne/' : '/prodotti/insalate',
'/prodotti-bonduelle/le-mama-non-mama/' : '/prodotti',
'/prodotti-bonduelle/le-monoverdure/' : '/prodotti/surgelati',
'/prodotti-bonduelle/le-regionali/' : '/prodotti/piatti-pronti',
'/prodotti-bonduelle/le-selezioni/' : '/prodotti',
'/prodotti-bonduelle/le-spadellate/' : '/prodotti/conserve',
'/prodotti-bonduelle/le-verdure-a-foglia/' : '/prodotti/surgelati',
'/prodotti-bonduelle/le-verdure-da-cuocere/' : '/prodotti',
'/prodotti-bonduelle/mix-di-verdure/' : '/prodotti/conserve',
'/prodotti-bonduelle/monovarieta/' : '/prodotti/insalate',
'/prodotti-bonduelle/surgelati/' : '/prodotti/surgelati',
'/prodotti-bonduelle/surgelati/page/2/' : '/prodotti/surgelati',
'/prodotti-bonduelle/surgelati/page/3/' : '/prodotti/surgelati',
'/prodotti-bonduelle/surgelati/page/4/' : '/prodotti/surgelati',
'/prodotti-bonduelle/zuppe/' : '/prodotti',
'/promuoviamo-utilizzo-di-confezioni-sostenibili/' : '/azienda/articolo/promuoviamo-lutilizzo-di-confezioni-sempre-piu-sostenibili/1766/1766',
'/promuoviamo-utilizzo-di-confezioni-sostenibili-temp' : '/azienda/articolo/promuoviamo-lutilizzo-di-confezioni-sempre-piu-sostenibili/1766/1766',
'/promuoviamo-utilizzo-di-confezioni-sostenibili-temp/' : '/azienda/articolo/promuoviamo-lutilizzo-di-confezioni-sempre-piu-sostenibili/1766/1766',
'/questionario-completato/' : '/',
'/ricettari/le-ricette-light/' : '/ricette',
'/ricettari/ricette-perfette-cena-elegante/' : '/ricette',
'/ricette/amore-mais-palline-melone-stracciatella/' : '/ricette',
'/ricette/amore-mais-rucola-radicchio-mini-pomodorini-farciti-bufala-olive/' : '/ricette',
'/ricette/amore-mais-rucola-radicchio-rosso-cestini-sfoglia/' : '/ricette',
'/ricette/anitra-glassata-cavolini/' : '/ricette',
'/ricette/arrostino-tacchino-al-crudo-pecorino-mix-vivace/' : '/ricette/r/arrosto-di-tacchino-con-crudo-e-pecorino-accompagnato-da-insalata/itgp131',
'/ricette/arrosto-maiale-trivoglio/' : '/ricette',
'/ricette/aspic-pollo-verdure/' : '/ricette',
'/ricette/bocconcini-pollo-fagiolata-piccante-guacamole/' : '/ricette',
'/ricette/bollibolli-pentolone/' : '/ricette',
'/ricette/bowl-sfiziosa-con-coccole-broccoli-e-carote-verdure-e-legumi/' : '/ricette/r/bowl-sfiziosa-con-coccole-broccoli-e-carote-verdure-e-legumi/itgp193',
'/ricette/bresaola-rucola-carote-salsa-citronette/' : '/ricette/r/bresaola-con-rucola-carote-e-salsa-citronette/itgp102',
'/ricette/bruschetta-burrata-pomodorini-tocco-soia-edamame-bonduelle/' : '/ricette/r/bruschetta-con-burrata-pomodorini-ed-edamame/itgp170',
'/ricette/burger-di-ceci/' : '/ricette/r/burger-di-ceci/itgp093',
'/ricette/burger-di-mais/' : '/ricette/r/burger-di-mais/itgp094',
'/ricette/calamari-lenticchie-farro-carote-piselli/' : '/ricette',
'/ricette/cannelloni-ricotta-spinaci/' : '/ricette',
'/ricette/cannoncini-omelette-rucola-carpaccio-mele-bresaola/' : '/ricette',
'/ricette/capitan-nemo-lesercito-dei-totani/' : '/ricette',
'/ricette/carotine-alla-crema/' : '/ricette',
'/ricette/carotine-cannella-rosmarino-crostini-pane/' : '/ricette',
'/ricette/carotine-primizia-alla-turca/' : '/ricette',
'/ricette/carta-delle-insalate-ricetta-croccante-con-salmone-affumicato-e-mango/' : '/ricette/r/insalata-con-salmone-affumicato-mango-e-feta/itgp130',
'/ricette/carta-delle-insalate-ricetta-croccante-con-tonno-scottato/' : '/ricette/r/insalata-con-tonno-scottato-e-mandorle/itgp125',
'/ricette/carta-delle-insalate-ricetta-deliziosa-con-raspadura-e-uovo-filante/' : '/ricette/r/insalata-con-raspadura-e-uovo-filante/itgp126',
'/ricette/carta-delle-insalate-ricetta-fragrante-con-carpaccio-di-pesce-spada/' : '/ricette/r/insalata-con-carpaccio-di-pesce-spada-e-lamponi/itgp124',
'/ricette/carta-delle-insalate-ricetta-limonetta-con-tagliata-di-manzo/' : '/ricette/r/tagliata-di-manzo-con-insalata/itgp129',
'/ricette/carta-delle-insalate-ricetta-piccantina-con-mele-speck-e-scaglie-di-formaggio/' : '/ricette/r/insalata-con-speck-mele-e-scaglie-di-formaggio/itgp133',
'/ricette/carta-delle-insalate-ricetta-vivace-avocado-melograno-ceci-e-fiocchi-di-latte/' : '/ricette/r/insalata-con-avocado-melograno-ceci-e-fiocchi-di-latte/itgp127',
'/ricette/cartocci-ceci-croccanti/' : '/ricette/r/cartocci-di-ceci-croccanti/itgp023',
'/ricette/cartoccio-verdure-veloce/' : '/ricette',
'/ricette/caserecce-pesto-leggero-fagiolini-patate/' : '/ricette',
'/ricette/cavatelli-cannellini-vongole/' : '/ricette/r/cavatelli-con-cannellini-e-vongole/itgp033',
'/ricette/cavatelli-mantecati-crema-piselli-piselli-croccanti/' : '/ricette',
'/ricette/cavolini-alla-tirolese/' : '/ricette',
'/ricette/ceasar-salad-con-carta-delle-insalate-ricetta-gustosa/' : '/ricette/r/caesar-salad/itgp128',
'/ricette/ceci-pomodorini-melanzane-al-forno-palline-robiola/' : '/ricette/r/ceci-con-pomodorini-melanzane-al-forno-e-robiola/itgp048',
'/ricette/cestini-cappuccetto-rosso/' : '/ricette',
'/ricette/cestini-di-burrata/' : '/ricette/r/cestini-di-burrata-con-melanzane-e-zucchine-grigliate-carote-e-pomodori/itgp183',
'/ricette/cestini-parmigiano-cime-rapa-acciughe-crema-mais/' : '/ricette/r/cestini-di-parmigiano-con-cime-di-rapa-acciughe-e-crema-di-mais/itgp158',
'/ricette/cestini-pasta-phillo-insalata-russa-ai-gamberi/' : '/ricette/r/cestini-di-pasta-fillo-con-insalata-russa-ai-gamberi/itgp071',
'/ricette/cestini-spinaci-ceci/' : '/ricette/r/cestini-con-spinaci-e-ceci/itgp199',
'/ricette/cesto-pane-ripieno-iceberg-carote-cetrioli-tonno-pomodoro/' : '/ricette',
'/ricette/cheesecake-fagiolini-copertura-pomodorini/' : '/ricette',
'/ricette/cielo-pecorelle/' : '/ricette',
'/ricette/classica-pasta-ceci/' : '/ricette/r/pasta-e-ceci/itgp022',
'/ricette/coccole-spinaci-fagiolini-broccoli-insalata-peperoni-pomodori/' : '/ricette',
'/ricette/coccole-zucca-e-carote-con-fonduta-di-parmigiano-e-padellata-di-carciofi-e-patate/' : '/ricette/r/coccole-zucca-e-carote-con-fonduta-di-parmigiano-e-padellata-di-carciofi-e-patate/itgp192',
'/ricette/cofanetti-piselli-carotine/' : '/ricette',
'/ricette/conchiglioni-gratinati-piselli-carotine-taleggio/' : '/ricette',
'/ricette/costolette-agnello-fagiolotti-verdi/' : '/ricette',
'/ricette/costolette-agnello-le-fave/' : '/ricette',
'/ricette/cotechino-con-lenticchie/' : '/ricette',
'/ricette/cotolette-borlotti-al-forno/' : '/ricette',
'/ricette/cous-cous-ceci-verdure/' : '/ricette/r/cous-cous-con-ceci-e-verdure/itgp035',
'/ricette/crema-ai-piselli-menta/' : '/ricette',
'/ricette/crema-al-limone-e-lamponi-con-il-tuo-tocco-di-ceci-alla-cannella/' : '/ricette/r/crema-al-limone-con-lamponi-e-ceci/itgp087',
'/ricette/crema-dolce-di-zucca-con-cioccolato-e-il-tuo-tocco-di-quinoa/' : '/ricette/r/crema-dolce-di-zucca-e-cioccolato-con-quinoa/itgp085',
'/ricette/crema-mais-natalizia/' : '/ricette/r/crema-di-mais-natalizia/itgp159',
'/ricette/crema-scalda-cuore/' : '/ricette',
'/ricette/crema-soffice-ceci-gamberoni/' : '/ricette/r/crema-soffice-di-ceci-con-gamberoni/itgp018',
'/ricette/crema-spinaci-leggera/' : '/ricette',
'/ricette/crema-spinaci-patate-al-castelmagno/' : '/ricette/r/vallutata-di-spinaci-e-patate-al-castelmagno/itgp074',
'/ricette/crespella-biete-erbette-cotto-besciamella/' : '/ricette/r/crespelle-con-biete-erbette-cotto-e-besciamella/itgp062',
'/ricette/crespelle-rucola-carote-crescenza-zucchine-basilico/' : '/ricette/r/crespelle-con-rucola-carote-crescenza-zucchine-e-basilico/itgp148',
'/ricette/crocchette-piselli-salsa-allo-yogurt-speziato/' : '/ricette',
'/ricette/crostatina-spinaci/' : '/ricette',
'/ricette/crostini-crema-lenticchie/' : '/ricette/r/crostini-con-crema-di-lenticchie/itgp017',
'/ricette/crostone-ai-4-formaggi-con-insalata-deliziosa-e-cipolla-caramellata/' : '/ricette/r/crostone-ai-4-formaggi-con-insalata-e-cipolla-caramellata/itgp136',
'/ricette/crostone-con-coccole-spinaci-fagiolini-e-broccoli-robiola-e-pomodori-secchi/' : '/ricette/r/crostone-con-coccole-robiola-e-pomodori-secchi/itgp195',
'/ricette/crostone-ratatouille-pate-olive/' : '/ricette',
'/ricette/crostoni-rucola-pere-cacio-noci/' : '/ricette/r/crostoni-cacio-e-pere-su-letto-di-rucola/itgp197',
'/ricette/crumble-alle-verdure/' : '/ricette',
'/ricette/crumble-di-fragole-con-il-tuo-tocco-di-quinoa/' : '/ricette/r/crumble-di-fragole-con-quinoa/itgp083',
'/ricette/cuor-lattuga-fragole-yogurt/' : '/ricette/r/insalata-con-fragole-e-feta/itgp150',
'/ricette/cupola-crespelle-fagiolini-besciamella/' : '/ricette',
'/ricette/curry-vegetariano-zucca-tocco-ceci-bonduelle/' : '/ricette',
'/ricette/curry-verde-con-taccole-e-gamberi/' : '/ricette/r/curry-verde-con-taccole-e-gamberi/itgp180',
'/ricette/dadolata-pollo-peperoni-il-tocco-mais-bonduelle/' : '/ricette/r/dadolata-di-pollo-e-peperoni-con-mais/itgp165',
'/ricette/dadolata-verdure-miste/' : '/ricette',
'/ricette/delizia-spinaci-gran-misto-verdure-gratinate/' : '/ricette/r/delizia-di-spinaci-con-gran-misto-di-verdure-gratinate/itgp200',
'/ricette/entrecote-manzo-pacchetti-fagiolini/' : '/ricette',
'/ricette/fagiolini-insalata-ciliegini-alle-erbe/' : '/ricette',
'/ricette/fagiolini-mais-carote-bonduelle-primosale-grigliato/' : '/ricette/r/insalata-di-rucola-carote-e-mais-con-primosale-alla-piastra-e-tapenade-di-olive/itgp108',
'/ricette/fagiolini-mais-carote-gamberi/' : '/ricette',
'/ricette/fagiolini-patate-citronette-crostini-alla-burrata/' : '/ricette/r/fagiolini-e-patate-con-citronette-e-crostini-alla-burrata/itgp185',
'/ricette/fagioli-rossi-spezie-allindiana/' : '/ricette/r/fagioli-rossi-con-spezie-all-indiana/itgp016',
'/ricette/fantasia-salmone-feta-trio-freschezza/' : '/ricette/r/insalata-con-mais-salmone-e-feta/itgp028',
'/ricette/farro-fagiolotti-sgombro/' : '/ricette',
'/ricette/filetti-trota-mais-piselli/' : '/ricette',
'/ricette/filetto-di-orata-in-crosta-di-pistacchi-con-contorno-di-carote-arancioni-e-gialle-taccole-e-pastinaca-al-cumino/' : '/ricette/r/filetto-di-orata-in-crosta-di-pistacchi-con-contorno-di-carote-arancioni-e-gialle-taccole-e-pastinaca-al-cumino/itgp181',
'/ricette/filetto-salmone-granella-pistacchi/' : '/ricette/r/filetto-di-salmone-con-granella-di-pistacchi/itgp072',
'/ricette/fili-gustosi-albicocche-secche-culatello-mandorle-salate/' : '/ricette/r/insalata-con-albicocche-secche-culatello-e-mandorle-salate/itgp144',
'/ricette/focaccia-bianca-primizie-stagione-acetosetta-camembert/' : '/ricette',
'/ricette/fricassea-carotine/' : '/ricette',
'/ricette/frisella-mista-fine-pate-carciofi-prosciutto-praga-pomodorini/' : '/ricette/r/frisella-con-insalata-pate-di-carciofi-prosciutto-di-praga-e-pomodorini/itgp146',
'/ricette/frittata-fagiolini-piselli/' : '/ricette',
'/ricette/frittata-fantasia/' : '/ricette/r/frittata-fantasia/itgp015',
'/ricette/frittata-ortolana/' : '/ricette',
'/ricette/funghetti/' : '/ricette',
'/ricette/fusilli-al-pesto-mais-dadolata-pomodori-rucola-carote/' : '/ricette/r/fusilli-al-pesto-con-mais-dadolata-di-pomodorini-rucola-e-carote/itgp107',
'/ricette/garganelli-al-ragu-piselli/' : '/ricette',
'/ricette/gazpacho-mais-freddo-gamberi-marinati-al-lime/' : '/ricette/r/gazpacho-di-mais-freddo-con-gamberi-marinati-al-lime/itgp157',
'/ricette/gnocchi-alla-romana-spinaci-millefoglie/' : '/ricette/r/gnocchi-alla-romana-con-spinaci/itgp004',
'/ricette/gnocchi-patate-broccoli-salmone-affumicato/' : '/ricette',
'/ricette/gran-mix-gustoso-cubetti-ananas-gamberi-fasciati-pancetta/' : '/ricette',
'/ricette/gran-mix-gustoso-mela-rossa-mandorle-french-dressing/' : '/ricette/r/insalata-con-mele-rosse-mandorle-e-french-dressing/itgp153',
'/ricette/hamburger-di-pollo-agli-aromi/' : '/ricette/r/hamburger-di-pollo-agli-aromi-con-broccoli-taccole-e-patate/itgp184',
'/ricette/hamburger-spinaci-millefoglie-allarancia/' : '/ricette/r/hamburger-con-spinaci-all-arancia/itgp188',
'/ricette/huevos-rancheros-tortillas/' : '/ricette',
'/ricette/hummus-libanese/' : '/ricette/r/hummus-libanese/itgp013',
'/ricette/iceberg-carote-cialdine-cous-cous-asparagi-uovo-barzotto/' : '/ricette/r/insalata-con-cialdine-di-cous-cous-asparagi-e-uovo-barzotto/itgp149',
'/ricette/iceberg-carote-polpette-ceci/' : '/ricette/r/insalata-con-polpette-di-ceci/itgp036',
'/ricette/iceberg-pomodorini-mais-formaggio/' : '/ricette/r/insalata-con-pomodorini-mais-e-formaggio/itgp027',
'/ricette/i-coniglietti/' : '/ricette',
'/ricette/insalata-ananas/' : '/ricette',
'/ricette/insalata-arcobaleno/' : '/ricette',
'/ricette/insalata-avocado-crudo-toscano/' : '/ricette/r/insalata-con-avocado-e-crudo-toscano/itgp058',
'/ricette/insalata-barbabietole-cubetti/' : '/ricette',
'/ricette/insalata-borlotti-alla-romana/' : '/ricette/r/insalata-di-borlotti-alla-romana/itgp009',
'/ricette/insalata-ceci-uova-rucola/' : '/ricette',
'/ricette/insalata-cous-cous-fagiolini/' : '/ricette/r/insalata-di-cous-cous-e-fagiolini/itgp008',
'/ricette/insalata-croccante-con-sashimi-di-salmone-alla-fiamma/' : '/ricette/r/insalata-con-sashimi-di-salmone-alla-fiamma/itgp202',
'/ricette/insalata-crudo-zucchine-piselli/' : '/ricette',
'/ricette/insalata-delle-feste/' : '/ricette',
'/ricette/insalata-del-sol-levante/' : '/ricette',
'/ricette/insalata-dinverno-2/' : '/ricette/r/insalata-d-inverno/itgp155',
'/ricette/insalata-di-pasta-con-pomodori-secchi-prezzemolo-noci-e-il-tuo-tocco-di-soia-edamame/' : '/ricette/r/insalata-di-pasta-con-pomodori-secchi-prezzemolo-noci-ed-edamame/itgp082',
'/ricette/insalata-di-riso-di-cavolfiore/' : '/ricette/r/insalata-di-riso-di-cavolfiore/itgp190',
'/ricette/insalata-di-riso-viola-con-carote-arancioni-e-gialle-taccole-e-pastinaca-bonduelle-con-limone-timo-e-olive-taggiasche/' : '/ricette/r/insalata-di-riso-viola-con-carote-arancioni-e-gialle-taccole-e-pastinaca-con-limone-timo-e-olive-taggiasche/itgp182',
'/ricette/insalata-fagiolini-bufala-schiacciatine-al-sesamo-pesto-leggero/' : '/ricette/r/insalata-di-fagiolini-con-bufala-schiacciatine-al-sesamo-e-pesto-leggero/itgp003',
'/ricette/insalata-fagiolini-patate/' : '/ricette/r/insalata-di-fagiolini-e-patate/itgp005',
'/ricette/insalata-fagiolini-tonno-capperi-pomodori/' : '/ricette',
'/ricette/insalata-finocchi-arance-tocco-soia-edamame-bonduelle/' : '/ricette/r/insalata-di-finocchi-e-arance-con-edamame/itgp067',
'/ricette/insalata-fredda-farro-taccole-menta-fave-pomodoro-confit/' : '/ricette/r/insalata-fredda-di-farro-con-taccole-menta-fave-e-pomodoro-confit/itgp068',
'/ricette/insalata-gamberi-mais-mele-rosse-pinoli/' : '/ricette/r/insalata-di-gamberi-mais-mele-e-pinoli/itgp024',
'/ricette/insalata-gamberi-pesche/' : '/ricette',
'/ricette/insalata-greca-olive-feta/' : '/ricette/r/insalata-greca-con-olive-e-feta/itgp060',
'/ricette/insalata-iceberg-carote-arance/' : '/ricette/r/insalata-con-caprino-e-arance/itgp047',
'/ricette/insalata-iceberg-salmone-avocado/' : '/ricette/r/avocado-con-iceberg-e-salmone/itgp038',
'/ricette/insalata-lenticchie-alla-curcuma-zucca/' : '/ricette',
'/ricette/insalata-limonetta-con-carne-salada-patate-arrosto-e-carciofi/' : '/ricette/r/tortino-di-patate-arrosto-carne-salada-e-carciofi-con-guarnizione-di-insalata/itgp135',
'/ricette/insalata-mais-fagioli-rossi/' : '/ricette/r/insalata-di-mais-e-fagioli-rossi/itgp007',
'/ricette/insalata-mediterranea-con-olive' : '/ricette',
'/ricette/insalata-o-brasil/' : '/ricette',
'/ricette/insalata-pasta-fredda/' : '/ricette/r/insalata-di-pasta-fredda/itgp006',
'/ricette/insalata-pasta-mais-armonia/' : '/ricette/r/insalata-di-pasta-fredda/itgp006',
'/ricette/insalata-pasta-rucola-prosciutto/' : '/ricette',
'/ricette/insalata-pollo-millefoglie/' : '/ricette/r/insalata-di-pollo-con-songino/itgp049',
'/ricette/insalata-porcini-bresaola-noci-parmigiano/' : '/ricette',
'/ricette/insalata-quinoa-alla-salome/' : '/ricette',
'/ricette/insalata-quinoa-piselli-gamberetti/' : '/ricette/r/insalata-di-quinoa-con-pisellini-e-gamberetti/itgp103',
'/ricette/insalata-riso-rosso-integrale-rucola-carote/' : '/ricette/r/insalata-di-riso-rosso-integrale-con-rucola-e-carote/itgp070',
'/ricette/insalata-rucola-carote-fiammifero-fave/' : '/ricette/r/insalata-di-rucola-carote-e-fave/itgp065',
'/ricette/insalata-rucola-fichi-bresaola-formaggio-capra/' : '/ricette/r/rucola-con-fichi-bresaola-e-formaggio-di-capra/itgp196',
'/ricette/insalata-russa-leggera/' : '/ricette',
'/ricette/insalata-russa-ricca/' : '/ricette',
'/ricette/insalata-salmone-marinato-germogli/' : '/ricette',
'/ricette/insalata-sapori-mediterranei/' : '/ricette',
'/ricette/insalata-spinaci-millefoglie-cous-cous-uvette-limone/' : '/ricette',
'/ricette/insalata-tacchino-olive-ed-emmenthal/' : '/ricette',
'/ricette/insalata-taccole-caprino/' : '/ricette',
'/ricette/insalata-taccole-uova-mimosa/' : '/ricette/r/insalata-di-taccole-con-uova-mimosa/itgp046',
'/ricette/insalata-tiepida-ai-piselli/' : '/ricette/r/insalata-tiepida-ai-piselli/itgp025',
'/ricette/insalata-tiepida-polpo-crema-cannellini/' : '/ricette/r/insalata-tiepida-di-polpo-con-crema-di-cannellini/itgp001',
'/ricette/insalata-tropicale-gamberi-pomodorini/' : '/ricette/r/insalata-tropicale-con-gamberi-e-pomodorini/itgp077',
'/ricette/insalata-verde/' : '/ricette',
'/ricette/insalata-verdure-grigliate/' : '/ricette/r/insalata-con-provola-e-verdure-grigliate/itgp063',
'/ricette/insalata-zen/' : '/ricette/r/insalata-zen/itgp026',
'/ricette/insalatona-barbabietole-provolone-arance-anacardi/' : '/ricette',
'/ricette/insalatona-cannellini-al-pesto-finocchietto-patate-tonno/' : '/ricette/r/insalatona-con-cannellini-al-pesto-di-finocchietto-patate-e-tonno/itgp032',
'/ricette/insalatona-con-olive-emmenthal-e-mele-al-curry/' : '/ricette/r/insalatona-con-olive-emmenthal-e-mele-al-curry/itgp134',
'/ricette/insalatona-invernale-patate-uova-feta/' : '/ricette/r/insalatona-invernale-con-patate-uova-e-feta/itgp104',
'/ricette/insalatona-primavera-con-melanzane-gratinate-bufaline-e-salsa-ai-pomodori/' : '/ricette/r/insalatona-con-melanzane-gratinate-bufaline-e-salsa-ai-pomodori/itgp141',
'/ricette/insalatona-ricca-gamberetti-ed-avocado/' : '/ricette/r/insalatona-ricca-con-gamberetti-ed-avocado/itgp051',
'/ricette/involtini-biete-erbette-speck-caciocavallo/' : '/ricette/r/involtini-di-biete-erbette-speck-e-caciocavallo-su-letto-di-insalata/itgp152',
'/ricette/involtini-melanzane-feta-menta-rucola-carote/' : '/ricette',
'/ricette/involtini-orata-ratatouille/' : '/ricette',
'/ricette/involtini-pollo-mortadella-alle-erbe-mais-olive-peperoni/' : '/ricette',
'/ricette/involtini-spada-ripieni/' : '/ricette',
'/ricette/involtini-spada-ripieni-2/' : '/ricette',
'/ricette/la-coppa-del-re/' : '/ricette',
'/ricette/lasagna-verde-scorza-limone-tocco-mais/' : '/ricette/r/lasagna-verde-con-scorza-di-limone-e-mais/itgp090',
'/ricette/lasagne-con-verdure-grigliate/' : '/ricette',
'/ricette/lattughino-bufala-zucchine-pomodorini-al-forno/' : '/ricette',
'/ricette/lattughino-polpette-polenta-allo-speck-stracchino/' : '/ricette/r/songino-con-triangoli-di-polenta-speck-e-castagne/itgp198',
'/ricette/la-vispa-farfalla/' : '/ricette',
'/ricette/le-coccole-broccoli-carote-feta-pomodori-grigliati/' : '/ricette/r/coccole-broccoli-e-carote-con-feta-e-pomodori-grigliati/itgp194',
'/ricette/le-girandole/' : '/ricette',
'/ricette/le-insalatine-chips-zucca/' : '/ricette',
'/ricette/lenticchie-agli-aromi/' : '/ricette/r/lenticchie-agli-aromi/itgp010',
'/ricette/lenticchie-farro-carote-piselli-zucchine-spadellate-timo-pinoli/' : '/ricette',
'/ricette/lenticchie-natale/' : '/ricette/r/lenticchie-la-ricetta-classica/itgp011',
'/ricette/lenticchie-pomodori-datterino-basilico-feta-fresca-olive-gaeta/' : '/ricette/r/insalata-di-lenticchie-con-pomodori-datterini-basilico-feta-fresca-e-olive-di-gaeta/itgp059',
'/ricette/lenticchie-ricetta-classica/' : '/ricette/r/lenticchie-la-ricetta-classica/itgp011',
'/ricette/lorso-mangia-fiori/' : '/ricette',
'/ricette/maionese-avocado-chips-platano-tocco-mais/' : '/ricette/r/maionese-di-avocado-con-chips-di-platano-e-mais/itgp163',
'/ricette/mais-affumicato/' : '/ricette',
'/ricette/mattonella-spinaci/' : '/ricette',
'/ricette/merluzzo-pinoli-gran-mix-gustoso/' : '/ricette',
'/ricette/mezzemaniche-fave-ricotta/' : '/ricette',
'/ricette/millefoglie-carciofi-grigliati-prosciutto-crudo-pomodori-secchi-scaglie-pecorino/' : '/ricette',
'/ricette/millefoglie-fragole-asparagi-gamberi-al-lime/' : '/ricette',
'/ricette/minestra-verdure/' : '/ricette',
'/ricette/minestrone-classico-gnocchetti-pane/' : '/ricette/r/minestrone-classico-con-gnocchetti-di-pane/itgp189',
'/ricette/minestrone-ricco-panini-alla-zucca/' : '/ricette/r/minestrone-classico-con-gnocchetti-di-pane/itgp189',
'/ricette/minestrone-ricco-passato-quenelle-alla-ricotta/' : '/ricette/r/minestrone-ricco-con-quenelle-di-ricotta/itgp061',
'/ricette/miniburger-vegetariani-con-coccole/' : '/ricette',
'/ricette/mini-cheesecake-salate-aromatizzate-alla-menta-tocco-ceci-bonduelle/' : '/ricette/r/mini-cheesecake-salata-aromatizzata-alla-menta-con-ceci/itgp091',
'/ricette/mini-piadine-con-verdure-di-stagione-crema-di-sesamo-e-il-tuo-tocco-di-ceci/' : '/ricette/r/mini-piadine-con-verdure-di-stagione.-crema-di-sesamo-e-ceci/itgp080',
'/ricette/mini-tigelle-squacquerone-tocco-ceci/' : '/ricette',
'/ricette/mista-dolce-lamponi-fettine-caco-vaniglia-scamorza-affumicata-dressing-al-lime/' : '/ricette/r/insalata-con-lamponi-fettine-di-caco-mela-scamorza-affumicata-e-dressing-al-lime/itgp154',
'/ricette/mista-fine-carciofi-crudi-prosciutto-crudo-stelline-pesto-rosso/' : '/ricette/r/insalata-con-carciofi-crudi-prosciutto-crudo-e-stelline-con-pesto-rosso/itgp143',
'/ricette/mix-croccante-cubetti-pesce-spada-granella-pistacchi/' : '/ricette/r/insalata-con-cubetti-di-pesce-spada-in-granella-di-pistacchi/itgp142',
'/ricette/mix-stagione-cetrioli-ravanelli-carciofini-dressing-allo-yogurt/' : '/ricette/r/insalata-con-cetrioli-ravanelli-carciofini-e-dressing-allo-yoghurt/itgp160',
'/ricette/mix-vivace-melanzane-grigliate-ricotta-infornata-pesto-basilico-pane-guttiau/' : '/ricette/r/insalata-con-melanzane-grigliate-ricotta-infornata-pesto-di-basilico-e-pane-guttiau/itgp145',
'/ricette/muffin-carote-salsa-allo-yogurt/' : '/ricette',
'/ricette/muffin-mais-cioccolato-bianco/' : '/ricette/r/muffin-di-mais-e-cioccolato-bianco/itgp203',
'/ricette/muffin-salati-con-pesto-di-rucola-e-il-tuo-tocco-di-mais/' : '/ricette/r/muffin-salati-con-pesto-di-rucola-e-mais/itgp081',
'/ricette/nidi-spaghetti-polpette-tocco-soia-edamame/' : '/ricette',
'/ricette/orecchiette-pasticciate-i-broccoli/' : '/ricette',
'/ricette/orecchiette-tris-cavoli-acciughe-pomodori-secchi/' : '/ricette/r/orecchiette-con-cavoli-acciughe-e-pomodori-secchi/itgp187',
'/ricette/padellata-verde-fave-carciofi-pinoli-agrodolce/' : '/ricette/r/vignarola/itgp044',
'/ricette/page/10/' : '/ricette',
'/ricette/page/11/' : '/ricette',
'/ricette/page/12/' : '/ricette',
'/ricette/page/13/' : '/ricette',
'/ricette/page/14/' : '/ricette',
'/ricette/page/15/' : '/ricette',
'/ricette/page/16/' : '/ricette',
'/ricette/page/17/' : '/ricette',
'/ricette/page/18/' : '/ricette',
'/ricette/page/19/' : '/ricette',
'/ricette/page/2/' : '/ricette',
'/ricette/page/20/' : '/ricette',
'/ricette/page/21/' : '/ricette',
'/ricette/page/22/' : '/ricette',
'/ricette/page/23/' : '/ricette',
'/ricette/page/24/' : '/ricette',
'/ricette/page/25/' : '/ricette',
'/ricette/page/26/' : '/ricette',
'/ricette/page/27/' : '/ricette',
'/ricette/page/28/' : '/ricette',
'/ricette/page/29/' : '/ricette',
'/ricette/page/3/' : '/ricette',
'/ricette/page/30/' : '/ricette',
'/ricette/page/31/' : '/ricette',
'/ricette/page/32/' : '/ricette',
'/ricette/page/33/' : '/ricette',
'/ricette/page/34/' : '/ricette',
'/ricette/page/35/' : '/ricette',
'/ricette/page/36/' : '/ricette',
'/ricette/page/4/' : '/ricette',
'/ricette/page/5/' : '/ricette',
'/ricette/page/6/' : '/ricette',
'/ricette/page/7/' : '/ricette',
'/ricette/page/8/' : '/ricette',
'/ricette/page/9/' : '/ricette',
'/ricette/pancake-salati-colorati-con-salsa-allo-yogurt-e-il-tuo-tocco-di-mais/' : '/ricette',
'/ricette/pancakes-salati-ai-cavoli/' : '/ricette',
'/ricette/panini-fiore/' : '/ricette',
'/ricette/panino-con-roast-beef-insalata-gustosa-pomodorini-confit-e-maionese/' : '/ricette/r/panino-con-roast-beef-insalata-pomodorini-confit-e-maionese/itgp137',
'/ricette/panzanella-ceci/' : '/ricette/r/panzanella-con-ceci/itgp012',
'/ricette/panzerotti-spinaci-millefoglie-bonduelle-prosciutto-formaggio/' : '/ricette',
'/ricette/pappardelle-asparagi-gamberetti/' : '/ricette',
'/ricette/pasta-e-fagioli/' : '/ricette/r/pasta-e-fagioli/itgp034',
'/ricette/pasta-fredda-di-mezza-estate/' : '/ricette',
'/ricette/pasta-integrale-spinaci-crema-formaggio-nocciole-limone/' : '/ricette/r/penne-integrali-con-spinaci-crema-di-formaggio-nocciole-e-limone/itgp064',
'/ricette/pasta-piselli-speck-zucchine-salsa-allo-zafferano/' : '/ricette/r/pasta-con-piselli-speck-zucchine-e-salsa-allo-zafferano/itgp002',
'/ricette/patate-ripiene-con-il-tuo-tocco-di-soia-edamame/' : '/ricette/r/patate-ripiene-di-funghi-ed-edamame/itgp084',
'/ricette/penne-integrali-alla-mediterranea/' : '/ricette/r/penne-integrali-alla-mediterranea/itgp099',
'/ricette/penne-lenticchie-e-carote-al-salmone-e-panna/' : '/ricette/r/penne-lenticchie-e-carote-al-salmone-e-panna/itgp176',
'/ricette/penne-lenticchie-e-carote-con-ragu-di-verdure-e-briciole-croccanti/' : '/ricette/r/penne-lenticchie-e-carote-con-ragu-di-verdure-e-briciole-croccanti/itgp175',
'/ricette/penne-lenticchie-e-carote-con-vongole-mazzancolle-e-zucchine/' : '/ricette/r/penne-lenticchie-e-carote-con-vongole-mazzancolle-e-zucchine/itgp174',
'/ricette/penne-nellorto/' : '/ricette',
'/ricette/penne-pesto-avocado-mais-piselli-bonduelle/' : '/ricette/r/penne-con-pesto-di-avocado-mais-e-piselli/itgp162',
'/ricette/pennette-integrali-vegetariane/' : '/ricette/r/pennette-integrali-vegetariane/itgp014',
'/ricette/peperoni-ripieni-al-mais/' : '/ricette',
'/ricette/pere-mele-fantasia-lattughino/' : '/ricette/r/fantasia-di-lattughino-con-pere-mele-e-uvetta/itgp097',
'/ricette/pesce-spada-piselli-medi-bonduelle/' : '/ricette',
'/ricette/pesto-alla-rucola/' : '/ricette',
'/ricette/piadina-al-condi-o-cuoci-gustoso/' : '/ricette',
'/ricette/picnic-le-sirene/' : '/ricette',
'/ricette/piselli-taccole-crumble-pane/' : '/ricette/r/rotolini-di-orata-con-crumble-di-piselli-e-taccole/itgp055',
'/ricette/pita-ripiena-con-millefoglie-scamorza-e-zucchine-grigliate/' : '/ricette/r/pita-con-insalata-scamorza-e-zucchine-grigliate/itgp161',
'/ricette/plumcake-al-mais-farina-cocco/' : '/ricette/r/plumcake-al-mais-e-farina-di-cocco/itgp095',
'/ricette/plumcake-bettelmatt-tocco-soia-edamame/' : '/ricette/r/plumcake-con-bettelmatt-ed-edamame/itgp167',
'/ricette/polenta-tazza-funghi-tocco-ceci/' : '/ricette',
'/ricette/pollo-al-salto-pannocchiette/' : '/ricette',
'/ricette/pollo-coppa-mais-asparagi/' : '/ricette',
'/ricette/polpette-pollo-ricotta-pistacchi-rucola-carote/' : '/ricette',
'/ricette/polpo-fagioli-borlotti/' : '/ricette/r/polpo-con-fagioli/itgp079',
'/ricette/pomodori-fagiolini-croccanti/' : '/ricette/r/insalata-di-pomodori-e-fagiolini-croccanti/itgp078',
'/ricette/pomodori-ripieni-mousse-avocado-tocco-quinoa-bonduelle/' : '/ricette/r/pomodori-ripieni-con-mousse-di-avocado-e-quinoa/itgp172',
'/ricette/prato-fiorito/' : '/ricette',
'/ricette/primizie-acetosetta-ribes-rosso-zola-piccante-pere/' : '/ricette/r/insalata-con-ribes-rosso-zola-piccante-e-pere/itgp132',
'/ricette/primizie-insalatine-gustose-salmone-affumicato-crostini-pane-nero/' : '/ricette/r/insalatina-con-salmone-affumicato-e-crostini-di-pane-nero/itgp040',
'/ricette/primizie-insalatine-tenere-anguria-feta-cipolla-rossa-olive-nere/' : '/ricette',
'/ricette/primizie-stagione-pane-croccante-allaceto-balsamico-salmone-affumicato/' : '/ricette',
'/ricette/pure-barbabietola-mele-verdi-tocco-quinoa-bonduelle/' : '/ricette/r/pure-di-barbabietola-mele-verdi-e-quinoa/itgp171',
'/ricette/quiche-fagiolini-piselli-ricotta/' : '/ricette',
'/ricette/quiche-leggera-alle-verdure/' : '/ricette',
'/ricette/quiche-rosette-cavolfiori/' : '/ricette',
'/ricette/quiche-salata-mais-fagiolini-pomodori-crescenza/' : '/ricette',
'/ricette/quinoa-alla-messicana-mais-fagioli-rossi/' : '/ricette/r/quinoa-alla-messicana-con-mais-e-fagioli-rossi/itgp037',
'/ricette/ravioli-al-condi-o-cuoci-dolce/' : '/ricette',
'/ricette/ravioli-bresaola-caprino-amore-mais-rucola-radicchio/' : '/ricette',
'/ricette/ravioli-san-valentino/' : '/ricette',
'/ricette/riccia-radicchio-peperoni-pomodori-secchi-patate-bollite-capperi-basilico/' : '/ricette/r/insalata-con-pomodori-secchi-patate-bollite-capperi-e-basilico/itgp147',
'/ricette/riccia-radicchio-peperoni-rotolini-zucchine-alla-robiola-prosciutto-praga/' : '/ricette',
'/ricette/ricettecarpaccio-polipo-fagiolini-bonduelle-spumoni-patate-salsa-ai-pomodori/' : '/ricette',
'/ricette/ricettecous-cous-gamberetti-zucchine-ceci-piselli-mirtilli/' : '/ricette',
'/ricette/ricettecous-cous-vegetariano-melanzane-feta-pomodori-secchi-il-tocco-ceci-bonduelle/' : '/ricette/r/cous-cous-vegetariano-con-melanzane-feta-pomodori-secchi-e-ceci/itgp050',
'/ricette/ricettefiletti-pesce-alla-mediterranea/' : '/ricette/r/filetti-di-pesce-alla-mediterranea/itgp053',
'/ricette/ricettegamberi-saltati-al-cognac/' : '/ricette',
'/ricette/ricetteinsalata-estiva-riso-rosso/' : '/ricette/r/insalata-estiva-di-riso-rosso/itgp039',
'/ricette/ricetteinsalata-giorno-soia-polpettine/' : '/ricette',
'/ricette/ricetteinsalata-giorno-tartare-tonno-marinato-allarancia-finocchi-olive-taggiasche/' : '/ricette/r/linsalata-del-giorno-con-tartare-di-tonno-marinato-allarancia-finocchi-e-olive-taggiasche/itgp100',
'/ricette/ricetteinsalata-giorno-uva-feta/' : '/ricette',
'/ricette/ricetteinsalata-gourmande-il-tocco-mais-bonduelle/' : '/ricette/r/insalata-gourmande-con-mais/itgp075',
'/ricette/ricetteinsalatona-sfiziosa-olive-pesce-spada-pompelmo-rosa-il-tocco-ceci-bonduelle/' : '/ricette/r/insalatona-sfiziosa-con-olive-pesce-spada-e-pompelmo-rosa-con-ceci/itgp112',
'/ricette/ricettelinsalata-giorno-gamberi-ceci-arance/' : '/ricette/r/insalata-con-gamberi-ceci-pomodori-secchi-e-arance/itgp057',
'/ricette/ricettelinsalata-giorno-straccetti-tacchino-mandarini/' : '/ricette/r/insalata-con-straccetti-di-tacchino-e-mandarini/itgp156',
'/ricette/ricettelinsalata-giorno-uva-nera-pecorino-noci-dressing-al-miele/' : '/ricette',
'/ricette/ricettepollo-agli-agrumi/' : '/ricette/r/pollo-agli-agrumi/itgp140',
'/ricette/ricetteriso-fantasia-mediterranea-il-tocco-mais-bonduelle/' : '/ricette/r/riso-fantasia-mediterranea/itgp054',
'/ricette/ricetterose-prosciutto-lattughino/' : '/ricette/r/rose-di-prosciutto-e-lattughino/itgp109',
'/ricette/ricettespiedini-formaggio/' : '/ricette/r/spiedini-di-frutta-e-formaggi-con-insalata-e-carote/itgp101',
'/ricette/ricettetagliata-manzo-al-pepe-rosa/' : '/ricette/r/tagliata-di-manzo-al-pepe-rosa/itgp105',
'/ricette/ricettetoast-pane-segale-hummus-zucca-uovo-poached-germogli-tocco-soia-edamame/' : '/ricette',
'/ricette/ricettetorta-salata-biete-erbette-cipolla/' : '/ricette/r/torta-salata-con-biete-erbette-e-cipolla/itgp111',
'/ricette/ricettevellutata-broccoli-il-tocco-ceci-bonduelle/' : '/ricette/r/vellutata-di-broccoli-con-ceci/itgp166',
'/ricette/rigatoni-piselli-e-zucchine-alle-triglie-e-zafferano/' : '/ricette/r/rigatoni-piselli-e-zucchine-con-triglie-e-zafferano/itgp179',
'/ricette/rigatoni-piselli-e-zucchine-con-pesto-pomodorini-secchi-e-fave/' : '/ricette/r/rigatoni-piselli-e-zucchine-con-pesto-pomodorini-secchi-e-fave/itgp178',
'/ricette/rigatoni-piselli-e-zucchine-con-salsa-di-pomodorini-alla-nduja-e-ricotta-salata/' : '/ricette/r/rigatoni-piselli-e-zucchine-con-salsa-di-pomodorini-alla-nduja-e-ricotta-salata/itgp177',
'/ricette/riso-alla-cantonese/' : '/ricette/r/riso-alla-cantonese/itgp191',
'/ricette/riso-alla-cantonese-mais/' : '/ricette/r/riso-alla-cantonese-con-mais/itgp041',
'/ricette/riso-alla-cantonese-mais/null' : '/ricette/r/riso-alla-cantonese-con-mais/itgp041',
'/ricette/riso-basmati-mais-piselli-carotine/' : '/ricette/r/riso-basmati-con-mais-piselli-e-carotine/itgp045',
'/ricette/riso-basmati-piselli-petali-frittata-crudo-rucola/' : '/ricette/r/riso-basmati-con-piselli-petali-di-frittata-crudo-e-rucola/itgp066',
'/ricette/riso-integrale-feta-tocco-soia-edamame/' : '/ricette/r/riso-integrale-con-feta-e-soia-edamame/itgp088',
'/ricette/riso-rosso-alla-curcuma-verdure-tocco-soia-edamame/' : '/ricette/r/riso-rosso-alla-curcuma-con-verdure-e-soia-edamame/itgp089',
'/ricette/risottino-spinaci-scamorza/' : '/ricette',
'/ricette/risotto-al-condi-o-cuoci/' : '/ricette',
'/ricette/risotto-piselli-finissimi-bonduelle-pomodoro-scamorza/' : '/ricette/r/risotto-con-piselli-pomodoro-e-scamorza/itgp069',
'/ricette/rotolini-mozzarella-prosciutto-trio-freschezza/' : '/ricette/r/rotolini-di-mozzarella-prosciutto-e-insalata/itgp151',
'/ricette/rucola-carote-mais-primosale-alla-piastra-tapenade-olive/' : '/ricette/r/insalata-di-rucola-carote-e-mais-con-primosale-alla-piastra-e-tapenade-di-olive/itgp108',
'/ricette/saccottini-salmone-cuore-caprino-letto-icerberg-carote/' : '/ricette',
'/ricette/salmone-alla-griglia-insalatina-tiepida-fave/' : '/ricette',
'/ricette/sfoglie-mezzelune-mais-piselli/' : '/ricette',
'/ricette/sformatini-di-verdure-con-tomini/' : '/ricette/r/sformatini-di-verdure-con-tomini-cremosi/itgp113',
'/ricette/sfreccia-la-freccia/' : '/ricette',
'/ricette/sogliola-alla-fiorentina/' : '/ricette',
'/ricette/songino-carciofi-grigliati-provolone/' : '/ricette',
'/ricette/songino-rucola-lattughino-asparagi-croccanti/' : '/ricette/r/insalata-con-asparagi-croccanti/itgp201',
'/ricette/songino-triangoli-polenta-castagne-speck/' : '/ricette/r/songino-con-triangoli-di-polenta-speck-e-castagne/itgp198',
'/ricette/spaghetti-riso-mais-gamberi-verdurine-croccanti/' : '/ricette/r/spaghetti-di-riso-con-mais-e-gamberi-e-verdurine-croccanti/itgp096',
'/ricette/spatzle-agli-spinaci/' : '/ricette',
'/ricette/spezzatino-vegetariano-piselli-carote-patate/' : '/ricette',
'/ricette/spicchi-sole/' : '/ricette',
'/ricette/spiedini-alla-griglia-profumati-alla-paprika/' : '/ricette/r/spiedini-alla-griglia-profumati-alla-paprika/itgp138',
'/ricette/spiedini-frutta-formaggi-mix-estate/' : '/ricette/r/spiedini-di-frutta-e-formaggi-con-insalata-e-carote/itgp101',
'/ricette/spiedini-gamberi-amore-mais-songino/' : '/ricette',
'/ricette/spiedini-verdure-grigliate/' : '/ricette',
'/ricette/spinaci-borlotti-aromatici/' : '/ricette/r/straccetti-di-pollo-al-lime-con-spinaci-borlotti-e-champignon-aromatici/itgp110',
'/ricette/spinaci-lenticchie-allarancia-mandorle/' : '/ricette',
'/ricette/spinacino-noci-ribes-roquefort-tocco-quinoa-bonduelle/' : '/ricette/r/spinacino-con-noci-roquefort-e-quinoa/itgp173',
'/ricette/stella-stellina/' : '/ricette',
'/ricette/sunday-roast-allinglese/' : '/ricette/r/sunday-roast-allinglese/itgp056',
'/ricette/tabule-tacchino/' : '/ricette',
'/ricette/tacos-avocado-gamberetti/' : '/ricette/r/tacos-con-avocado-e-gamberetti/itgp042',
'/ricette/tagliatelle-cotto-piselli-al-profumo-menta/' : '/ricette',
'/ricette/tagliatelle-fave-ricotta-dura/' : '/ricette',
'/ricette/tagliatelle-riso-agrodolce-piselli-carotine-germogli/' : '/ricette',
'/ricette/tagliatelle-riso-julienne-verdure-salmone-ed-tocco-soia-edamame-bonduelle/' : '/ricette/r/tagliatelle-di-riso-con-julienne-di-verdure-salmone-ed-edamame/itgp098',
'/ricette/tataki-tonno-mousse-al-caprino-tempura-verdure/' : '/ricette',
'/ricette/tavolozza-legumi/' : '/ricette',
'/ricette/tenere-insalatine-fichi-crudo-crostini-pane/' : '/ricette',
'/ricette/tenere-insalatine-pollo-avocado-pompelmo/' : '/ricette/r/tenere-insalatine-con-pollo-avocado-e-pompelmo/itgp029',
'/ricette/tenere-insalatine-spada-affumicato-marinato-allarancia-olive-taggiasche-pistacchi/' : '/ricette',
'/ricette/terrina-ricotta-fantasie-verdure/' : '/ricette',
'/ricette/terrina-spinaci/' : '/ricette',
'/ricette/tiella-riso-mais-olive-peperoni/' : '/ricette',
'/ricette/tomini-alla-griglia/' : '/ricette/r/tomini-alla-griglia/itgp139',
'/ricette/torta-carote-mais/' : '/ricette/r/torta-di-carote-e-mais/itgp030',
'/ricette/torta-pasqualina/' : '/ricette',
'/ricette/torta-salata-piselli-carotine/' : '/ricette/r/torta-salata-con-piselli-e-carotine/itgp076',
'/ricette/tortelli-dellalto-adige/' : '/ricette',
'/ricette/tortine-riso-piselli/' : '/ricette',
'/ricette/tortino-caco-zola-tocco-soia-edamame/' : '/ricette/r/tortino-caco-zola-patate-ed-edamame/itgp168',
'/ricette/tranci-salmone-pure-piselli-alla-menta/' : '/ricette',
'/ricette/tris-cavoli-uvetta-briciole-pane-pinoli/' : '/ricette',
'/ricette/vellutata-cannellini/' : '/ricette/r/vellutata-di-cannellini/itgp020',
'/ricette/vellutata-patate-viola-crumble-nocciole-tocco-ceci/' : '/ricette',
'/ricette/vellutata-piselli-uovo-forma-cuore-morbido-chips-pecorino-pomodori-confit/' : '/ricette',
'/ricette/verdure-autunnali-glassate-spolverata-mais-curcuma/' : '/ricette/r/verdure-autunnali-glassate-con-spolverata-di-mais-e-curcuma/itgp164',
'/ricette/zuppa-borlotti-pancetta/' : '/ricette/r/zuppa-di-borlotti-e-pancetta/itgp019',
'/ricette/zuppa-borlotti-pancetta/null' : '/ricette/r/zuppa-di-borlotti-e-pancetta/itgp019',
'/ricette/zuppa-carciofi-piselli/' : '/ricette/r/zuppa-di-piselli-e-carciofi/itgp106',
'/ricette/zuppa-contadina-fagioli-rossi/' : '/ricette/r/zuppa-contadina-con-fagioli-rossi/itgp052',
'/ricette/zuppa-cremosa-cavolini/' : '/ricette',
'/ricette/zuppa-iceberg-ceci/' : '/ricette',
'/ricette/zuppa-lenticchie-farro-carote-piselli/' : '/ricette/r/zuppa-di-lenticchie-farro-carote-e-piselli/itgp021',
'/ricette/zuppa-lenticchie-patate-zucca/' : '/ricette/r/zuppa-di-lenticchie-patate-e-zucca/itgp043',
'/ricette/zuppa-spinaci-fagioli-cannellini/' : '/ricette/r/zuppa-di-spinaci-e-cannellini/itgp031',
'/ricette-calorie/201-400/' : '/ricette',
'/ricette-calorie/248/' : '/ricette',
'/ricette-calorie/250/' : '/ricette',
'/ricette-calorie/300/' : '/ricette',
'/ricette-calorie/340/' : '/ricette',
'/ricette-calorie/400/' : '/ricette',
'/ricette-calorie/401-600/' : '/ricette',
'/ricette-calorie/401-600/?s=600+calorie' : '/ricette',
'/ricette-calorie/410/' : '/ricette',
'/ricette-calorie/427/' : '/ricette',
'/ricette-calorie/fino-a-200/' : '/ricette',
'/ricette-cmais/' : '/ricette',
'/ricette-con/100-cavolfiore-in-forma-di-riso/' : '/ricette',
'/ricette-con/armonia/' : '/ricette',
'/ricette-con/asparagi-verdi-in-vetro/' : '/ricette',
'/ricette-con/asparagi-verdi-in-vetro/?s=' : '/ricette',
'/ricette-con/barbabietole-a-cubetti/' : '/ricette',
'/ricette-con/bebio-carote/' : '/ricette',
'/ricette-con/bebio-insalatine-gustose/' : '/ricette',
'/ricette-con/bebio-lattughino/' : '/ricette',
'/ricette-con/bebio-minestrone/' : '/ricette',
'/ricette-con/bebio-mix-sfizioso/' : '/ricette',
'/ricette-con/bebio-piselli/' : '/ricette',
'/ricette-con/bebio-spinaci/' : '/ricette',
'/ricette-con/biete-erbette-millefoglie/' : '/ricette',
'/ricette-con/borlotti-al-vapore/' : '/ricette',
'/ricette-con/borlotti-in-vetro-2/' : '/ricette',
'/ricette-con/broccoli-taccole-e-patate/' : '/ricette',
'/ricette-con/burger-di-bulgur-e-quinoa/' : '/ricette',
'/ricette-con/burger-di-farro-e-amaranto/' : '/ricette',
'/ricette-con/cannellini-al-vapore/' : '/ricette',
'/ricette-con/cannellini-in-vetro/' : '/ricette',
'/ricette-con/carote-a-fiammifero/' : '/ricette',
'/ricette-con/carote-arancioni-e-gialle-taccole-e-pastinaca/' : '/ricette',
'/ricette-con/carotine-primizia/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-croccante/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-deliziosa/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-fragrante/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-gustosa/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-limonetta/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-olive/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-piccantina/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-saporita/' : '/ricette',
'/ricette-con/carta-delle-insalate-ricetta-vivace/' : '/ricette',
'/ricette-con/cavolini-di-bruxelles/' : '/ricette',
'/ricette-con/ceci-al-vapore/' : '/ricette',
'/ricette-con/ceci-al-vapore/page/2/' : '/ricette',
'/ricette-con/ceci-in-vetro-2/' : '/ricette',
'/ricette-con/cous-cous/' : '/ricette',
'/ricette-con/cous-cous-con-pollo-e-verdure/' : '/ricette',
'/ricette-con/cous-cous-delizioso/' : '/ricette',
'/ricette-con/cuor-di-lattuga/' : '/ricette',
'/ricette-con/delizia-di-spinaci/' : '/ricette',
'/ricette-con/fagiolini-e-patate/' : '/ricette',
'/ricette-con/fagiolini-extra-fini/' : '/ricette',
'/ricette-con/fagiolini-extra-fini-cotti-al-vapore/' : '/ricette',
'/ricette-con/fagiolini-fini-cotti-al-vapore/' : '/ricette',
'/ricette-con/fagiolini-fini-tagliati-cotti-al-vapore-2/' : '/ricette',
'/ricette-con/fagiolini-fini-tagliati-in-vetro-5-2/' : '/ricette',
'/ricette-con/fagioli-rossi-al-vapore/' : '/ricette',
'/ricette-con/fagiolotti-verdi/' : '/ricette',
'/ricette-con/fantasia-di-bulgur/' : '/ricette',
'/ricette-con/fantasia-di-verdure/' : '/ricette',
'/ricette-con/fantasia-di-verdure/?s=Fantasia+di+verdure' : '/ricette',
'/ricette-con/farro-alla-mediterranea-con-feta-dop/' : '/ricette',
'/ricette-con/fave-al-vapore/' : '/ricette',
'/ricette-con/fave-al-vapore/?s=Fave+al+vapore' : '/ricette',
'/ricette-con/funghi-champignon-tagliati/' : '/ricette',
'/ricette-con/gentilina/' : '/ricette',
'/ricette-con/germogli/' : '/ricette',
'/ricette-con/gran-mix-gustoso/' : '/ricette',
'/ricette-con/grano-saraceno-bulgur-e-quinoa/' : '/ricette',
'/ricette-con/gratin-di-patate-e-spinaci/' : '/ricette',
'/ricette-con/iceberg/' : '/ricette',
'/ricette-con/il-lattughino/' : '/ricette',
'/ricette-con/il-songino/' : '/ricette',
'/ricette-con/il-tuo-tocco-di-ceci/' : '/ricette',
'/ricette-con/il-tuo-tocco-di-ceci/page/2/' : '/ricette',
'/ricette-con/il-tuo-tocco-di-mais/' : '/ricette',
'/ricette-con/il-tuo-tocco-di-quinoa/' : '/ricette',
'/ricette-con/il-tuo-tocco-di-soia-edamame/' : '/ricette',
'/ricette-con/insalata-di-lusia-i-g-p/' : '/ricette',
'/ricette-con/insalata-dorzo-con-tonno/' : '/ricette',
'/ricette-con/la-rucola/' : '/ricette',
'/ricette-con/lattughino/' : '/ricette',
'/ricette-con/le-coccole-broccoli-e-carote/' : '/ricette',
'/ricette-con/le-coccole-spinaci-fagiolini-e-broccoli/' : '/ricette',
'/ricette-con/le-coccole-zucca-e-carote/' : '/ricette',
'/ricette-con/lenticchie-e-carote-in-forma-di-penne/' : '/ricette',
'/ricette-con/lenticchie-farro-carote-e-piselli/' : '/ricette',
'/ricette-con/lenticchie-piccole-al-vapore/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-greca/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-ligure/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-lombarda/' : '/ricette',
'/ricette-con/le-regionali-ricetta-allamericana/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-norvegese/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-pugliese/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-sarda/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-siciliana/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-trentina/' : '/ricette',
'/ricette-con/le-regionali-ricetta-alla-veneta/' : '/ricette',
'/ricette-con/le-spadellate-mix-gourmande/' : '/ricette',
'/ricette-con/le-spadellate-mix-rustico/' : '/ricette',
'/ricette-con/le-tenere-insalatine/' : '/ricette',
'/ricette-con/linsalata-del-giorno/' : '/ricette',
'/ricette-con/lo-spinacino/' : '/ricette',
'/ricette-con/mais/' : '/ricette',
'/ricette-con/mais/page/2/' : '/ricette',
'/ricette-con/mais/page/3/' : '/ricette',
'/ricette-con/mais-bio/' : '/ricette',
'/ricette-con/mais-carote-e-fagiolini/' : '/ricette',
'/ricette-con/mais-e-fagioli-rossi/' : '/ricette',
'/ricette-con/mais-e-piselli/' : '/ricette',
'/ricette-con/mais-olive-e-peperoni/' : '/ricette',
'/ricette-con/melanzane-e-zucchine-grigliate/' : '/ricette',
'/ricette-con/minestrone-classico/' : '/ricette',
'/ricette-con/minestrone-ricco-con-passato/' : '/ricette',
'/ricette-con/mista/' : '/ricette',
'/ricette-con/mix-cereali-e-verdure/' : '/ricette',
'/ricette-con/mix-di-farro/' : '/ricette',
'/ricette-con/mix-di-orzo-farro-e-quinoa-rossa/' : '/ricette',
'/ricette-con/mix-lattugoso/' : '/ricette',
'/ricette-con/mix-prezioso/' : '/ricette',
'/ricette-con/mix-rucoloso/' : '/ricette',
'/ricette-con/orzo-e-farro/' : '/ricette',
'/ricette-con/piselli-bio/' : '/ricette',
'/ricette-con/piselli-carotine-e-mais/' : '/ricette',
'/ricette-con/piselli-e-carotine-2/' : '/ricette',
'/ricette-con/piselli-extra-fini-in-vetro/' : '/ricette',
'/ricette-con/piselli-e-zucchine-in-forma-di-rigatoni/' : '/ricette',
'/ricette-con/piselli-fini-senza-zuccheri-aggiunti/' : '/ricette',
'/ricette-con/piselli-finissimi-senza-zuccheri-aggiunti/' : '/ricette',
'/ricette-con/piselli-medi-senza-zuccheri-aggiunti/' : '/ricette',
'/ricette-con/piselli-medi-senza-zuccheri-aggiunti/page/2/' : '/ricette',
'/ricette-con/pisellini-extra-fini/' : '/ricette',
'/ricette-con/piselli-novelli-fini/' : '/ricette',
'/ricette-con/ratatouille/' : '/ricette',
'/ricette-con/riso-venere-sfizioso/' : '/ricette',
'/ricette-con/rucola/' : '/ricette',
'/ricette-con/songino/' : '/ricette',
'/ricette-con/songino-radicchio/' : '/ricette',
'/ricette-con/spinaci-in-foglia/' : '/ricette',
'/ricette-con/spinaci-millefoglie/' : '/ricette',
'/ricette-con/spinaci-pronti-da-cuocere/' : '/ricette',
'/ricette-con/spinaci-tritati/' : '/ricette',
'/ricette-con/taccole/' : '/ricette',
'/ricette-con/taccole-tagliate/' : '/ricette',
'/ricette-con/tempura-di-verdure/' : '/ricette',
'/ricette-con/trio-freschezza/' : '/ricette',
'/ricette-con/tris-di-cavoli/' : '/ricette',
'/ricette-con/trivoglio/' : '/ricette',
'/ricette-con/verdure-per-insalata-russa/' : '/ricette',
'/ricette-occasione/bambini/page/2/' : '/ricette-di-cucina',
'/ricette-occasione/bambini/page/3/' : '/ricette-di-cucina',
'/ricette-occasione/elegante/page/2/' : '/ricette-di-cucina',
'/ricette-occasione/elegante/page/3/' : '/ricette-di-cucina',
'/ricette-piatti/antipasto/' : '/ricette/antipasti-aperitivi',
'/ricette-piatti/antipasto/page/2/' : '/ricette/antipasti-aperitivi',
'/ricette-piatti/antipasto/page/3/' : '/ricette/antipasti-aperitivi',
'/ricette-piatti/antipasto/page/4/' : '/ricette/antipasti-aperitivi',
'/ricette-piatti/antipasto/page/5/' : '/ricette/antipasti-aperitivi',
'/ricette-piatti/aperitivo/' : '/ricette/antipasti-aperitivi',
'/ricette-piatti/contorno/' : '/ricette/contorni',
'/ricette-piatti/contorno/page/2/' : '/ricette/contorni',
'/ricette-piatti/contorno/page/3/' : '/ricette/contorni',
'/ricette-piatti/contorno/page/4/' : '/ricette/contorni',
'/ricette-piatti/contorno/page/5/' : '/ricette/contorni',
'/ricette-piatti/dolce/' : '/ricette/dolci',
'/ricette-piatti/piatto-unico/' : '/ricette/insalate-piatti-unici',
'/ricette-piatti/piatto-unico/page/3/' : '/ricette/insalate-piatti-unici',
'/ricette-piatti/piatto-unico/page/4/' : '/ricette/insalate-piatti-unici',
'/ricette-piatti/primo/page/3/' : '/ricette/primi-piatti',
'/ricette-piatti/secondo/page/3/' : '/ricette/secondi-piatti',
'/ricette-piatti/secondo/page/5/' : '/ricette/secondi-piatti',
'/riduciamo-al-minimo-utilizzo-additivi-e-conservanti' : '/azienda/articolo/bonduelle-si-impegnariduciamo-al-minimo-lo-utilizzo-di-additivi-e-conservanti/887/128',
'/riduciamo-al-minimo-utilizzo-additivi-e-conservanti-temp' : '/azienda/articolo/bonduelle-si-impegnariduciamo-al-minimo-lo-utilizzo-di-additivi-e-conservanti/887/128',
'/ristorante/' : '/',
'/ristorante/12-morsi/' : '/',
'/ristorante/5-cinque/' : '/',
'/ristorante/agriturismo-coroncina/' : '/',
'/ristorante/agriturismo-corte-mainolda/' : '/',
'/ristorante/agriturismo-il-rigo/' : '/',
'/ristorante/agriturismo-le-tortorelle/' : '/',
'/ristorante/alessandro-cappotto-villa-calini/' : '/',
'/ristorante/al-fornello-ricci/' : '/',
'/ristorante/alpe-selviana/' : '/',
'/ristorante/ambasciata-orsarese/' : '/',
'/ristorante/angiolina/' : '/',
'/ristorante/antica-fattoria-la-parrina/' : '/',
'/ristorante/antica-hostaria-pacetti/' : '/',
'/ristorante/arancia-blu/' : '/',
'/ristorante/arca/' : '/',
'/ristorante/arcobaleno/' : '/',
'/ristorante/aromaticus/' : '/',
'/ristorante/atman/' : '/',
'/ristorante/baccano/' : '/',
'/ristorante/berbere/' : '/',
'/ristorante/bistrot/' : '/',
'/ristorante/borgo-spoltino/' : '/',
'/ristorante/caraceni/' : '/',
'/ristorante/carminio/' : '/',
'/ristorante/carpaccio/' : '/',
'/ristorante/casetta/' : '/',
'/ristorante/cento3cento/' : '/',
'/ristorante/chiccoteca/' : '/',
'/ristorante/ciao-checca/' : '/',
'/ristorante/civico-25/' : '/',
'/ristorante/corte-verze/' : '/',
'/ristorante/cortile-arabo/' : '/',
'/ristorante/cotto-crudo/' : '/',
'/ristorante/cutilisci/' : '/',
'/ristorante/dalie-fagioli/' : '/',
'/ristorante/degusteria-magnatum/' : '/',
'/ristorante/dopolavoro-la-foce/' : '/',
'/ristorante/doro/' : '/',
'/ristorante/era-ora/' : '/',
'/ristorante/estravagario/' : '/',
'/ristorante/ezio-al-ponte/' : '/',
'/ristorante/fattoria-dei-matti/' : '/',
'/ristorante/gardenia/' : '/',
'/ristorante/giardino-bacco/' : '/',
'/ristorante/gigliotto/' : '/',
'/ristorante/gino-pina/' : '/',
'/ristorante/godenda/' : '/',
'/ristorante/gologone/' : '/',
'/ristorante/guardastelle/' : '/',
'/ristorante/haiku/' : '/',
'/ristorante/il-gelato-claudio-torce/' : '/',
'/ristorante/il-lupo/' : '/',
'/ristorante/il-salto-bio/' : '/',
'/ristorante/i-tigli-theoria/' : '/',
'/ristorante/ivana-secondo/' : '/',
'/ristorante/konnubio/' : '/',
'/ristorante/la-brinca/' : '/',
'/ristorante/la-cerqua-la-balucca/' : '/',
'/ristorante/la-ciau-del-tornavento/' : '/',
'/ristorante/la-cucina-giuditta/' : '/',
'/ristorante/la-fata-zucchina/' : '/',
'/ristorante/laite/' : '/',
'/ristorante/la-lanterna-diogene/' : '/',
'/ristorante/la-limonaia-villa-acquaviva/' : '/',
'/ristorante/la-locanda-della-gola/' : '/',
'/ristorante/la-locandiera/' : '/',
'/ristorante/lama-san-giorgio-2/' : '/',
'/ristorante/lantico-forziere/' : '/',
'/ristorante/lape-il-girasole/' : '/',
'/ristorante/la-susina/' : '/',
'/ristorante/la-tavola-del-carmine/' : '/',
'/ristorante/la-tradizione-cucina-casalinga/' : '/',
'/ristorante/l-bunet/' : '/',
'/ristorante/le-delizie-maria/' : '/',
'/ristorante/le-maschere/' : '/',
'/ristorante/le-quattro-fontane/' : '/',
'/ristorante/les-neiges-dantan/' : '/',
'/ristorante/le-stanzie/' : '/',
'/ristorante/letizia/' : '/',
'/ristorante/locanda-manthone/' : '/',
'/ristorante/loste-della-bonora/' : '/',
'/ristorante/malga-panna/' : '/',
'/ristorante/malvarina/' : '/',
'/ristorante/mare/' : '/',
'/ristorante/mariu/' : '/',
'/ristorante/masseria-barbera/' : '/',
'/ristorante/megaron/' : '/',
'/ristorante/mint/' : '/',
'/ristorante/moma/' : '/',
'/ristorante/m-s/' : '/',
'/ristorante/nandas/' : '/',
'/ristorante/osteria-della-corte/' : '/',
'/ristorante/osteria-del-leone/' : '/',
'/ristorante/osteria-la-zucca/' : '/',
'/ristorante/osteria-porta-cicca/' : '/',
'/ristorante/pasto-giusto/' : '/',
'/ristorante/peppe-zullo/' : '/',
'/ristorante/pianura-delle-vigne/' : '/',
'/ristorante/podere-la-cerreta/' : '/',
'/ristorante/profumo-sole/' : '/',
'/ristorante/quattro-stagioni-dellagriturismo-la-fiorida/' : '/',
'/ristorante/radicetonda/' : '/',
'/ristorante/rec-23/' : '/',
'/ristorante/recreu/' : '/',
'/ristorante/relais-forti/' : '/',
'/ristorante/ristoro-la-dispensa/' : '/',
'/ristorante/roccafiore-resort/' : '/',
'/ristorante/rosti-al-pigneto/' : '/',
'/ristorante/sapposentu-casa-puddu/' : '/',
'/ristorante/sergio/' : '/',
'/ristorante/soncino' : '/',
'/ristorante/so-what/' : '/',
'/ristorante/taverna-dei-caldora/' : '/',
'/ristorante/taverna-kus/' : '/',
'/ristorante/taverna-li-jalantuumene/' : '/',
'/ristorante/terra-etrusca/' : '/',
'/ristorante/thats-vapore/' : '/',
'/ristorante/tipico/' : '/',
'/ristorante/trattoria-campagna/' : '/',
'/ristorante/trattoria-la-pecora-nera/' : '/',
'/ristorante/trattoria-pautassi/' : '/',
'/ristorante/trattoria-verdiana/' : '/',
'/ristorante/u-giancu/' : '/',
'/ristorante/valle-serena-del-relais-borgo-santo-pietro/' : '/',
'/ristorante/vecchia-malcesine/' : '/',
'/ristorante/villa-raino/' : '/',
'/ristorante/violetta/' : '/',
'/ristorante/vite/' : '/',
'/ristoranti-per-regione/abruzzo/' : '/',
'/ristoranti-per-regione/basilicata/' : '/',
'/ristoranti-per-regione/calabria/' : '/',
'/ristoranti-per-regione/campania/' : '/',
'/ristoranti-per-regione/campania/page/2/' : '/',
'/ristoranti-per-regione/emilia-romagna/' : '/',
'/ristoranti-per-regione/emilia-romagna/page/2/' : '/',
'/ristoranti-per-regione/friuli-venezia-giulia/' : '/',
'/ristoranti-per-regione/lazio/' : '/',
'/ristoranti-per-regione/lazio/page/2/' : '/',
'/ristoranti-per-regione/lazio/page/3/' : '/',
'/ristoranti-per-regione/liguria/' : '/',
'/ristoranti-per-regione/lombardia/' : '/',
'/ristoranti-per-regione/lombardia/page/2/' : '/',
'/ristoranti-per-regione/lombardia/page/3/' : '/',
'/ristoranti-per-regione/marche/' : '/',
'/ristoranti-per-regione/molise/' : '/',
'/ristoranti-per-regione/piemonte/' : '/',
'/ristoranti-per-regione/puglia/' : '/',
'/ristoranti-per-regione/puglia/page/2/' : '/',
'/ristoranti-per-regione/sardegna/' : '/',
'/ristoranti-per-regione/sicilia/' : '/',
'/ristoranti-per-regione/toscana/' : '/',
'/ristoranti-per-regione/toscana/page/2/' : '/',
'/ristoranti-per-regione/trentino-alto-adige/' : '/',
'/ristoranti-per-regione/umbria/' : '/',
'/ristoranti-per-regione/umbria/page/2/' : '/',
'/ristoranti-per-regione/valle-daosta/' : '/',
'/ristoranti-per-regione/veneto/' : '/',
'/scrivici/' : '/contatto',
'/segnala-ristorante/' : '/',
'/senza-categoria/meringhe-spinaci/' : '/ricette',
'/senza-categoria/mio-tocco-chic-dal-piatto-alla-tavola-lasagna-verde-scorza-limone-tocco-mais/' : '/ricette/r/lasagna-verde-con-scorza-di-limone-e-mais/itgp090',
'/senza-categoria/osare-segreto-riso-rosso-alla-curcuma-verdure-tocco-soia-edamame/' : '/ricette/r/riso-rosso-alla-curcuma-con-verdure-e-soia-edamame/itgp089',
'/servizio-commerciale/' : '/contatto',
'/servizio-consumatori/' : '/contatto',
'/servizio-consumatori/birraperoni.it' : '/',
'/socialsalad/' : '/',
'/socialsalad-intro/' : '/',
'/tag/aglio-nero/' : '/veggie-passion/veggie-passion',
'/tag/baccala/' : '/veggie-passion/veggie-passion',
'/tag/ceci-neri/' : '/veggie-passion/veggie-passion',
'/tag/cibi-che-fanno-bene/' : '/veggie-passion/veggie-passion',
'/tag/eventi-milano/' : '/',
'/tag/fagiolini-ricette/' : '/ricette',
'/tag/gravidanza/' : '/veggie-passion/veggie-passion',
'/tag/milano/' : '/',
'/tag/ortaggi/' : '/veggie-passion/veggie-passion',
'/tag/pak-choi/' : '/veggie-passion/veggie-passion',
'/tag/proprieta-carote/' : '/veggie-passion/veggie-passion',
'/tag/ricette-broccoli/' : '/veggie-passion/veggie-passion',
'/tag/ricette-con-mais/' : '/ricette',
'/tag/salute-occhi/' : '/veggie-passion/veggie-passion',
'/tag/semi-di-chia/' : '/veggie-passion/veggie-passion',
'/tag/spezie/' : '/veggie-passion/veggie-passion',
'/tag/svezzamento-neonati/' : '/veggie-passion/veggie-passion',
'/tag/topinambur/' : '/veggie-passion/veggie-passion',
'/tag/zucchine-dieta/' : '/veggie-passion/veggie-passion',
'/tag/zucchine-valori-nutrizionali/' : '/veggie-passion/veggie-passion',
'/user/BonduelleFSFrance' : '/',
'/user/BonduelleItalia' : '/',
'/user/BonduelleItalia/community' : '/',
'/user/BonduelleItalia/featured' : '/',
'/user/BonduelleItalia/search' : '/',
'/user/BonduelleItalia/videos' : '/',
'/user/MTVitaliaOfficial/search' : '/',
'/user/MTVitaliaOfficial/videos' : '/',
'/user/TopdelTubo' : '/',
'/user/TopdelTubo/videos' : '/',
'/user/UniBgTube/videos' : '/',
'/verdure/' : '/azienda/abc-verdure',
'/verdure/aglio/' : '/azienda/abc-verdure/aglio-proprieta-benefici-usi-in-cucina/2074/2074',
'/verdure/asparago/' : '/azienda/abc-verdure/asparagi-proprieta-benefici-usi-in-cucina/2075/2075',
'/verdure/barbabietola/' : '/azienda/abc-verdure/barbabietola-rossa-proprieta-benefici-usi-in-cucina/1641/1641',
'/verdure/bietola-costa/' : '/azienda/abc-verdure/bietola-da-costa-proprieta-benefici-usi-in-cucina/2076/2076',
'/verdure/broccolo/' : '/azienda/abc-verdure/broccoli-proprieta-benefici-usi-in-cucina/1889/1889',
'/verdure/carciofo/' : '/azienda/abc-verdure/carciofi-proprieta-benefici-usi-in-cucina/2077/2077',
'/verdure/cardo/' : '/azienda/abc-verdure/cardo-proprieta-benefici-usi-in-cucina/2078/2078',
'/verdure/carota/' : '/azienda/abc-verdure/carote-proprieta-benefici-usi-in-cucina/893/97',
'/verdure/cavolfiore/' : '/azienda/abc-verdure/cavolfiore-proprieta-benefici-usi-in-cucina/1898/1898',
'/verdure/cece/' : '/azienda/abc-verdure/ceci-proprieta-benefici-usi-in-cucina/1639/1639',
'/verdure/cetriolo/' : '/azienda/abc-verdure/cetrioli-proprieta-benefici-usi-in-cucina/1642/1642',
'/verdure/cipolla/' : '/azienda/abc-verdure/cipolla-proprieta-benefici-usi-in-cucina/1644/1644',
'/verdure/fagiolino/' : '/azienda/abc-verdure/fagiolini-proprieta-benefici-usi-in-cucina/1640/1640',
'/verdure/fagiolo/' : '/azienda/abc-verdure/fagioli-proprieta-benefici-usi-in-cucina/1909/1909',
'/verdure/fava/' : '/azienda/abc-verdure/fave-proprieta-benefici-usi-in-cucina/2079/2079',
'/verdure/germogli-fagiolo-mungo/' : '/azienda/abc-verdure/germogli-di-fagiolo-mungo-proprieta-benefici-usi-in-cucina/2080/2080',
'/verdure/indivia/' : '/azienda/abc-verdure/indivia-proprieta-benefici-usi-in-cucina/1897/1897',
'/verdure/lattuga/' : '/azienda/abc-verdure/lattuga-proprieta-benefici-usi-in-cucina/1895/1895',
'/verdure/lenticchie/' : '/azienda/abc-verdure/lenticchie-proprieta-benefici-usi-in-cucina/2081/2081',
'/verdure/mais/' : '/azienda/abc-verdure/mais-proprieta-benefici-usi-in-cucina/1879/1879',
'/verdure/melanzana/' : '/azienda/abc-verdure/melanzane-proprieta-benefici-usi-in-cucina/1890/1890',
'/verdure/page/2/' : '/azienda/abc-verdure',
'/verdure/page/4/' : '/azienda/abc-verdure',
'/verdure/patata/' : '/azienda/abc-verdure/patata-proprieta-benefici-usi-in-cucina/2082/2082',
'/verdure/peperone/' : '/azienda/abc-verdure/peperoni-proprieta-benefici-usi-in-cucina/1899/1899',
'/verdure/pisello/' : '/azienda/abc-verdure/piselli-proprieta-benefici-usi-in-cucina/1887/1887',
'/verdure/pomodoro/' : '/azienda/abc-verdure/pomodoro-proprieta-benefici-usi-in-cucina/2083/2083',
'/verdure/porro/' : '/azienda/abc-verdure/porro-proprieta-benefici-usi-in-cucina/1902/1902',
'/verdure/prezzemolo/' : '/azienda/abc-verdure/prezzemolo-proprieta-benefici-usi-in-cucina/2084/2084',
'/verdure/rapa/' : '/azienda/abc-verdure/rape-proprieta-benefici-usi-in-cucina/1903/1903',
'/verdure/ravanello/' : '/azienda/abc-verdure/ravanelli-proprieta-benefici-usi-in-cucina/1904/1904',
'/verdure/rucola/' : '/azienda/abc-verdure/rucola-proprieta-benefici-usi-in-cucina/1892/1892',
'/verdure/scalogno/' : '/azienda/abc-verdure/scalogno-proprieta-benefici-usi-in-cucina/2085/2085',
'/verdure/scorzonera/' : '/azienda/abc-verdure/scorzonera-proprieta-benefici-usi-in-cucina/1905/1905',
'/verdure/sedano' : '/azienda/abc-verdure/sedano-proprieta-benefici-in-cucina/1901/1901',
'/verdure/soia/' : '/azienda/abc-verdure/soia-proprieta-benefici-usi-in-cucina/2086/2086',
'/verdure/soncino/' : '/azienda/abc-verdure/songino-proprieta-benefici-usi-in-cucina/1896/1896',
'/verdure/spinacio/' : '/azienda/abc-verdure/spinaci-proprieta-benefici-usi-in-cucina/1906/1906',
'/verdure/topinambur/' : '/azienda/abc-verdure/topinambur-proprieta-benefici-usi-in-cucina/2087/2087',
'/verdure/zucca/' : '/azienda/abc-verdure/zucca-proprieta-benefici-usi-in-cucina/2088/2088',
'/verdure/zucchina/' : '/azienda/abc-verdure/zucchine-proprieta-benefici-usi-in-cucina/1888/1888',
'/vinci-disney-con-bonduelle/' : '/promozioni',
'/vinci-frigo-whirlpool-bonduelle/' : '/promozioni',
'/vinci-la-vacanza-dei-tuoi-sogni/' : '/promozioni',
'/bonduelle/tecnologie/conserve/%20france' : '/azienda/articolo/la-filiera-delle-conserve/1770/1770',
'/buoni%20in%20tavola' : '/promozioni',
'/buoni%20sconto' : '/promozioni',
'/comunicazione/comunicati-stampa/bonduelle-lancia-%20i-burger-bio-piacere-100-vegetale/' : '/azienda/novita',
'/cookblog/vegetal-news/discorsi-piante/Cook&Blog%20|%20Vegetal%20News' : '/veggie-passion/alimentazione-curiosita',
'/cookblog/vegetal-news/un-capolavoro-di-verdura/Cook&Blog%20|%20Vegetal%20News' : '/veggie-passion/alimentazione-curiosita',
'/in-pausa/%20cereali' : '/',
'/prodotti/categoria-prodotto%/tempura-di-verdure/bonduelle%20foodservice' : '/prodotti/p/tempura-di-verdure/03083681079449',
'/prodotti/il%20tuo%20tocco%20di%20ceci' : '/prodotti/p/il-tuo-tocco-di-ceci/03083681068146',
'/prodotti/i-legumi/ceci-cotti-al-vapore/%20monidose' : '/prodotti/p/ceci-al-vapore/03083681003949',
'/prodotti/i-piatti-pronti/delizia-spinaci/%20cottura' : '/prodotti/p/delizia-di-spinaci/03083680886420',
'/prodotti/i-piatti-pronti/delizia-spinaci/come%20si%20cy' : '/prodotti/p/delizia-di-spinaci/03083680886420',
'/prodotti/i-piatti-pronti/le-coccole-spinaci-fagiolini-broccoli/%20surgelati' : '/prodotti/p/coccole-spinaci-fagiolini-e-broccoli/03083681116274',
'/prodotti/i-piatti-pronti/le-coccole-zucca%20e%20carote/' : '/prodotti/p/coccole-zucca-e-carote/03083681116267',
'/prodotti/le-altre-monoverdure/carotine-primizia-lattina-piccola/BONDUELLE%20RUCOLA%20GR%2070%20BUSTA%20STAND%20UP' : '/prodotti/p/carotine-primizia/03083680020732',
'/prodotti/le-basi-per-cucinare/verdure-insalata-russa/%20ekom' : '/prodotti/p/verdure-per-insalata-russa/03083680017626',
'/prodotti/le-spadellate/mix-gourmande/%20en%20francais' : '/prodotti/p/mix-gourmande/03083681069877',
'/prodotti-bonduelle/fresco/linea%20biologica' : '/prodotti/bio',
'/ricette/ricette%20con%20le%20fave-fave-ricotta/' : '/ricette'
}
